import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Typography,
  Tab,
  Tabs,
  CircularProgress,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Chip,
  Drawer,
  AvatarGroup,
  Avatar
} from '@mui/material';
import './ViewShipment.css';
import {
  GetBillOfLading,
  GetProofOfDelivery,
  GetQuoteDetail,
  GetShipmentDetails,
  TrackShipmentRequest
} from '../../apis/Agency';
import { useSelector } from 'react-redux';
import { saveAs } from 'file-saver';
import { ErrorToast } from '../../components/Toasts';
import { Col, Row } from 'reactstrap';
import CachedIcon from '@mui/icons-material/Cached';
import TrackShipmentDetails from '../TrackShipment/TrackShipmentDetails';
import TrackHistory from '../TrackShipment/TrackHistory';
import DownloadIcon from '@mui/icons-material/Download';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { base_logo_url } from '../../apis/constants';
import CloseIcon from '@mui/icons-material/Close';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import Barcode from 'react-barcode';
import html2pdf from 'html2pdf.js';
import NoLogo from '../../assets/carrier logos/No Logo.png';
import Checkbox from '@mui/material/Checkbox';
import './bol_table.css';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import DoneIcon from '@mui/icons-material/Done';
import { useReactToPrint } from 'react-to-print';
import { formatPhoneNumber } from '../../apis/Utils';

const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

const CustomTable = ({ rowData, rowData2 }) => {
  const rows = rowData.map((data, index) => (
    <tr key={index}>
      <td className='bol-value'>{data?.units}</td>
      <td className='bol-value'>{data?.pieces}</td>
      <td className='bol-value'>{data?.packagingType}</td>
      <td className='bol-value'>{data?.netWeight} lbs</td>
      <td className='bol-value'>{data?.nmfc}</td>
      <td>
        <div
        // style={{ margin: 9 }}
        // className='d-flex align-items-center justify-content-between'
        >
          <Checkbox disabled {...label} checked={data?.isStackable} />
        </div>
      </td>
      <td className='bol-value'>{data?.itemDescription}</td>
      <td className='bol-value'>{data?.freightClass}</td>
      <td className='bol-value'>
        {data?.length} x {data?.width} x {data?.height}
      </td>
    </tr>
  ));
  const totalNetWeight = rowData.reduce((sum, item) => sum + item.netWeight, 0);
  const totalUnits = rowData.reduce((sum, item) => sum + item.units, 0);
  const totalPieces = rowData.reduce((sum, item) => sum + item.pieces, 0);
  return (
    <>
      <table className='custom-table'>
        <thead style={{ backgroundColor: 'rgb(222 222 222)' }}>
          <tr>
            <th className='custom-col-100 bol-label'>H/U</th>
            <th className='custom-col-100 bol-label'>Pieces</th>
            <th className='custom-col-100 bol-label'>Type</th>
            <th className='custom-col-100 bol-label'>Weight</th>
            {/* <th className='custom-col-100 bol-label'>HM (X)</th> */}
            <th className='custom-col-100 bol-label'>NMFC</th>
            <th className='custom-col-100 bol-label'>Stackable</th>
            <th className='custom-col-500 bol-label'>Item Description</th>
            <th className='custom-col-100 bol-label'>Freight Class</th>
            <th className='custom-col-100 bol-label'>Dimensions</th>
          </tr>
        </thead>
        {/* <tbody>{rows}</tbody>/ */}
        <tbody>{rows}</tbody>
      </table>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-evenly',
          border: '0.5px solid black',
          alignItems: 'center',
          borderTop: '0'
        }}
      >
        <div style={{ marginLeft: -105 }} className='bol-label'>
          Totals:
        </div>
        <div className='bol-value'>{totalUnits} H/Us</div>
        <div className='bol-value'>{totalNetWeight} Pounds</div>

        <div className='bol-value'>
          {totalPieces} Pieces On {totalUnits} Handling Units
        </div>
      </div>
      <div
        style={{
          border: '0.5px solid black',
          borderTop: '0'
        }}
      >
        <div style={{ padding: 10 }} className='bol-value'>
          Where the rate is dependent on value, shippers are required to state
          specifically in writing the agreed or declared value of the property
          as follows: “The agreed or declared value of the property is
          specifically stated by the shipper to be not exceeding ______________
          per ______________.
        </div>
      </div>
      {/* <div
        style={{
          border: '0.5px solid black',
          borderTop: '0',
          fontSize: 16,
          fontWeight: 'bold'
        }}
      >
        <div style={{ marginLeft: 5, marginRight: 5 }}>Remit COD to:</div>
      </div> */}
      {/* <div
        style={{
          border: '0.5px solid black',
          borderTop: '0',
          fontSize: 16,
          fontWeight: 'bold'
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginLeft: 5,
            marginRight: 5
          }}
        >
          <div>
            Collect{' '}
            <Checkbox
              disabled
              {...label}
              checked={rowData2?.freightTerms === 'InboundCollect'}
            />
          </div>
          <div>
            Prepaid{' '}
            <Checkbox
              {...label}
              disabled
              checked={rowData2?.freightTerms === 'OutboundPrepaid'}
            />
          </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            COD Amount: $ <b>{rowData2?.shipmentCharges}</b>
          </div>
        </div>
      </div> */}
      <div
        style={{
          border: '0.5px solid black',
          borderTop: '0',
          fontSize: 16
          // fontWeight: 'bold'
        }}
      >
        <div style={{ padding: 10 }}>
          <span className='bol-label'>NOTE:</span>
          <span className='bol-value'>
            Liability Limitation for loss or damage in this shipment may be
            applicable. See 49 U.S.C. 14706(c)(1)(A) and (B).
          </span>
        </div>
      </div>
      <div
        style={{
          border: '0.5px solid black',
          borderTop: '0'
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginLeft: 5,
            marginRight: 5
          }}
        >
          <div
            style={{ borderRight: '0.5px solid black', padding: 10 }}
            className='bol-value'
          >
            Received, subject to individually determined rates or contracts that
            have been agreed upon in writing between the carrier and shipper, if
            applicable, otherwise to the rates, classifications and rules that
            have been established by the carrier and are available to the
            shipper, on request, and to all applicable state and federal
            regulations.
          </div>
          <div
            style={{
              borderRight: '0.5px solid black',
              width: 400,
              padding: 10
            }}
            className='bol-label'
          >
            Trailer Loaded:
          </div>
          <div
            style={{
              borderRight: '0.5px solid black',
              width: 400,
              padding: 10
            }}
            className='bol-label'
          >
            Freight Counted:
          </div>
          <div style={{ padding: 10 }} className='bol-label'>
            The carrier shall not make delivery of this shipment without payment
            of freight and all other lawful charges.
            <br />
            Shipper: _____________
          </div>
        </div>
      </div>
      <div
        style={{
          border: '0.5px solid black',
          borderTop: '0'
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between'
          }}
        >
          <div style={{ borderRight: '0.5px solid black', padding: 10 }}>
            <span className='bol-label'>Shipper Signature/Date:</span>
            <br />
            <span className='bol-value'>
              This is to certify that the here-in named materials are properly
              classified, described, packaged, marked and labeled, and are in
              proper condition for transportation according to the applicable
              regulations of the Department of Transportation.
            </span>
            <br />
            <br />
            <span className='bol-label'>
              Shipper:____________________________________
            </span>
          </div>

          <div
            style={{
              padding: 10
            }}
          >
            <span className='bol-label'>
              Carrier Signature/Pickup Signature/Date:
            </span>
            <br />
            <span className='bol-value'>
              Carrier acknowledges receipt of packages and required placards.
              Carrier certifies emergency response information was made
              available and/or carrier has the Department of Transportation
              emergency response guidebook.
            </span>
            <br />
            <br />
            <span className='bol-label'>
              Carrier:____________________________________
            </span>
          </div>
        </div>
      </div>
    </>
  );
};
// VERTICAL

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ px: 1, width: '115%' }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`
  };
}

// HORIZONTAL

function TabPanelX(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ px: 3, py: 1, maxWidth: '100%' }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanelX.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired
};

function ViewShipment(props) {
  const contentRef = useRef(null);

  const [openPrintPDfDialogData, setOpenPrintPDfDialogData] = useState('');
  const [numberOfPrintsColmnVise, setNumberOfPrintsColmnVise] = useState(1);
  const [selectedPrintOption, setSelectedPrintOption] = useState(1);
  const [numberOfPrints, setNumberOfPrints] = useState(1);

  const [viewShipmentsDetails, setViewShipmentsDetails] = useState([]);

  const handleFetchShipmentsDetails = row => {
    GetShipmentDetails(rowData.shipmentId)
      .then(res => res.status === 200 && setViewShipmentsDetails(res.data.data))
      .catch(err => ErrorToast(err?.message));
  };

  useEffect(() => {
    handleFetchShipmentsDetails(props.rowData.shipmentId);
  }, []);

  const handleAfterPrint = React.useCallback(() => {}, []);

  const handleBeforePrint = React.useCallback(() => {
    return Promise.resolve();
  }, []);

  const handlePrint = useReactToPrint({
    // contentRef: contentRef,
    content: () => contentRef.current,
    documentTitle: `${openPrintPDfDialogData.carrierName} labels`,
    onAfterPrint: handleAfterPrint,
    onBeforePrint: handleBeforePrint
  });

  const handleDateTimeShow = (timeStamp, type) => {
    const dateTimeString = timeStamp + 'Z';
    const dateTime = new Date(dateTimeString);
    const date = new Date(dateTimeString);
    const bolDate = new Date(timeStamp);
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const timeOptions = new Intl.DateTimeFormat('default', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      timeZone: userTimeZone
    }).format(dateTime);

    const dateOptions = {
      // weekday: 'short',
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    };

    const bolDateOptions = {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric'
    };

    const formattedDate = date.toLocaleDateString(undefined, dateOptions);
    const options = { year: 'numeric', month: 'numeric', day: 'numeric' };
    const formattedBolDate = bolDate.toLocaleDateString('en-US', options);
    if (type === 'time') {
      return timeOptions;
    }
    if (type === 'date') {
      return formattedDate;
    }
    if (type === 'bol') {
      return formattedBolDate;
    }
  };
  const shipmentStatus = props?.rowData?.shipmentStatus;
  const [trackShipmentData, setTrackShipmentData] = useState(null);

  const handleSuccessTrackShip = apiRes => {
    setLoader(false);
    setTrackShipmentData(apiRes);
    // history.push({
    //   pathname: '/track-shipment',
    //   state: { trackShipmentData: apiRes }
    // });
  };
  const AgencyID = useSelector(state => state.userDetails.agencyLoginID);
  const [blobUrlBOL, setBlobUrlBOL] = useState('');
  const [blobUrlPOD, setBlobUrlPOD] = useState('');
  const [loader, setLoader] = useState(false);
  const [docLoader, setDocLoader] = useState(false);
  const [historyError, setHistoryError] = useState(false);
  const [PodDocLoader, setPodDocLoader] = useState(false);
  const [viewType, setViewType] = useState('Track');
  const AgencyAdminDetails = useSelector(
    state => state.user.AgencyAdminDetails
  );
  const handleTrackShipmentRequest = (selectedRowData, event, type) => {
    if (type === 'history') {
      setViewType(type);
      event.stopPropagation();
    } else {
      setLoader(true);
      event.stopPropagation();
      const obj = {
        carrierInfo: {
          id: selectedRowData?.carrierId ? selectedRowData.carrierId : 0,
          name: selectedRowData?.carrierName ? selectedRowData.carrierName : '',
          logo: ''
        },
        proNumber: selectedRowData?.proNumber,
        shipmentId: selectedRowData?.shipmentId,
        locationId: selectedRowData?.locationId,
        shipmentType: selectedRowData?.shipmentType,
        agencyId: AgencyID ? AgencyID : 0
      };

      TrackShipmentRequest(obj)
        .then(res => res.status === 200 && handleSuccessTrackShip(res.data))
        .catch(err => {
          setLoader(false);
          ErrorToast(JSON.stringify(err?.response?.data));
        });
    }
  };

  const viewBOL = (fileType, base64Data, urls, fileName) => {
    // console.log(urls[0], 'BOL');
    let mimeType;
    if (base64Data !== null) {
      switch (fileType.toLowerCase()) {
        case 'pdf':
          mimeType = 'application/pdf';
          break;
        case 'tif':
        case 'tiff':
        case 'tifv':
          mimeType = 'image/tiff';
          break;
        case '.gif':
        case 'gif':
          mimeType = 'image/gif';
          break;
        case 'jpg':
        case '.jpg':
          mimeType = 'image/jpg';
          break;
        default:
          console.error('Unsupported file type');
          return;
      }

      const linkSource = `data:${mimeType};base64,${base64Data}`;
      const downloadLink = document.createElement('a');
      downloadLink.href = linkSource;

      // Set the download attribute with the correct file extension
      downloadLink.download = fileName.endsWith(`.${fileType}`)
        ? fileName
        : `${fileName}.${fileType}`;

      // Trigger the download
      downloadLink.click();
    }
    if (urls !== null) {
      window.open(urls[0]);
    }

    // if (pdf.includes('tif') || pdf.includes('TIF')) {
    //   var base64regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
    //   if (base64regex.test(base64Data)) {
    //     setBlobUrlBOL(null);
    //     const linkSource = `data:image/tiff;base64,${base64Data}`;
    //     const downloadLink = document.createElement('a');
    //     downloadLink.href = linkSource;
    //     downloadLink.download = fileName;
    //     downloadLink.click();
    //   }
    // }
    // if ((pdf.includes('pdf') || pdf.includes('PDF')) && base64Data) {
    //   const byteArray = Uint8Array.from(atob(base64Data), c => c.charCodeAt(0));
    //   const blob = new Blob([byteArray], { type: 'application/pdf' }); // Change the MIME type according to your file type
    //   const url = URL.createObjectURL(blob);
    //   setBlobUrlBOL(url);
    // }
  };
  const viewPOD = (fileType, base64Data, urls, fileName) => {
    let mimeType;
    if (base64Data !== null) {
      switch (fileType.toLowerCase()) {
        case 'pdf':
        case '.pdf':
          mimeType = 'application/pdf';
          break;
        case 'tif':
        case 'tiff':
        case 'tifv':
          mimeType = 'image/tiff';
          break;
        case '.gif':
        case 'gif':
          mimeType = 'image/gif';
          break;
        case 'jpg':
        case '.jpg':
          mimeType = 'image/jpg';
          break;
        default:
          ErrorToast('Unsupported file type');
          return;
      }

      const linkSource = `data:${mimeType};base64,${base64Data}`;
      const downloadLink = document.createElement('a');
      downloadLink.href = linkSource;

      // Set the download attribute with the correct file extension
      downloadLink.download = fileName.endsWith(`.${fileType}`)
        ? fileName
        : `${fileName}.${fileType}`;

      // Trigger the download
      downloadLink.click();
    }
    if (urls && Array.isArray(urls)) {
      urls.forEach(url => {
        if (url) {
          window.open(url, '_blank');
        }
      });
    }
    // if (pdf.includes('tif') || pdf.includes('TIF')) {
    //   var base64regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
    //   if (base64regex.test(base64Data)) {
    //     setBlobUrlPOD(null);
    //     const linkSource = `data:image/tiff;base64,${base64Data}`;
    //     const downloadLink = document.createElement('a');
    //     downloadLink.href = linkSource;
    //     downloadLink.download = fileName;
    //     downloadLink.click();
    //   }
    // }
    // if ((pdf.includes('pdf') || pdf.includes('PDF')) && base64Data) {
    //   const byteArray = Uint8Array.from(atob(base64Data), c => c.charCodeAt(0));
    //   const blob = new Blob([byteArray], { type: 'application/pdf' }); // Change the MIME type according to your file type
    //   const url = URL.createObjectURL(blob);
    //   setBlobUrlPOD(url);
    // }
  };

  function handleSuccessBOL(pdf, base64Data, fileName) {
    if (pdf.includes('pdf') || pdf.includes('PDF')) {
      const byteCharacters = atob(base64Data);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const fileBlob = new Blob([byteArray], { type: 'application/pdf' });
      saveAs(fileBlob, fileName);
    }
    if (pdf.includes('tiff') || pdf.includes('TIFF')) {
      var base64regex =
        /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
      if (base64regex.test(base64Data)) {
        const linkSource = `data:${pdf};base64,${base64Data}`;
        const downloadLink = document.createElement('a');
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      }
    }
  }
  const handleProofOfDeliveryRequest = status => {
    setPodDocLoader(true);
    const obj = {
      carrier: {
        id: rowData?.carrierId ? rowData.carrierId : 0,
        name: rowData?.carrierName ? rowData.carrierName : 'string',
        logo: 'string'
      },
      proNumber: rowData?.proNumber.trim(),
      shipmentId: rowData?.shipmentId,
      locationId: rowData?.locationId,
      agencyId: AgencyID ? AgencyID : 0
    };
    GetProofOfDelivery(obj)
      .then(res => {
        res.status === 200 && setPodDocLoader(false);
        viewPOD(
          res.data.fileExtension,
          res.data.fileBase64,
          res.data.urLs,
          `Proof of Delivery (${obj.carrier.name}  ${obj.proNumber})`
        );
      })
      .catch(err => {
        setPodDocLoader(false);
        setBlobUrlPOD(null);
        ErrorToast(JSON.stringify(err?.response?.data));
      });
  };

  const handleBillOfLadingRequest = status => {
    setDocLoader(true);
    const obj = {
      carrier: {
        id: rowData?.carrierId ? rowData.carrierId : 0,
        name: rowData?.carrierName ? rowData.carrierName : 'string',
        logo: 'string'
      },
      proNumber: rowData?.proNumber.trim(),
      shipmentId: rowData?.shipmentId,
      locationId: rowData?.locationId,
      agencyId: AgencyID ? AgencyID : 0
    };

    GetBillOfLading(obj)
      .then(res => {
        res.status === 200 && setDocLoader(false);
        viewBOL(
          res.data.fileExtension,
          res.data.fileBase64,
          res.data.urLs,
          `Bill of Lading (${obj.carrier.name}  ${obj.proNumber})`
        );
      })
      .catch(err => {
        setBlobUrlBOL(null);
        setDocLoader(false);
        ErrorToast(JSON.stringify(err?.response?.data));
      });
  };

  const rowData = props?.rowData;

  // Vertical

  const [valueY, setValueY] = useState(0);
  const [shipperApiMsgs, setShipperApiMsgs] = useState('');
  const [carrierApiMsgs, setCarrierApiMsgs] = useState('');
  const [corresHistory, setCorresHistory] = useState('');
  const [openPrintPDfDialog, setOpenPrintPDfDialog] = useState(false);
  const [openLabelsDialog, setOpenLabelsDialog] = useState(false);
  const [openPDfPackagingSlip, setOpenPDfPackagingSlip] = useState(false);

  const [TLCoressPDrawer, setTLCoressPDrawer] = useState(false);
  const handleCloaseTLCoressPDrawer = () => {
    setValueY(0);
    setTLCoressPDrawer(false);
  };

  const handleSuccessResponse = apiRes => {
    setHistoryError(false);
    const carrierData = apiRes.data.data.details.filter(
      items => items.actionByFlag.toLowerCase() === 'carrier'
    );

    setShipperApiMsgs(apiRes.data.data.details);
    setCarrierApiMsgs(carrierData);
    setDocLoader(false);
  };

  const handleGetCorrHistory = apiRes => {
    const shipperSessionId = apiRes?.quoteCarriers?.find(
      ratesArr => ratesArr.carrierResponseStatus === 'ACCEPTED'
    );
    if (rowData?.sessionId) {
      GetQuoteDetail(rowData?.sessionId)
        .then(res => res.status === 200 && handleSuccessResponse(res))
        .catch(err => {
          setDocLoader(false);
          ErrorToast(err?.message);
        });
    } else {
      // ErrorToast('No history found against this shipment!');
      setHistoryError(true);
      setDocLoader(false);
    }
  };

  const handleGetQuote = () => {
    handleGetCorrHistory();
    // GetQuote(rowData?.quoteId)
    //   .then(res => {
    //     res.status === 200 && handleGetCorrHistory(res.data.data);
    //     setDocLoader(false);
    //   })
    //   .catch(err => console.log(err, 'TL quote Err----->>>>'));
  };
  const handleChangeY = (event, newValue) => {
    setValueY(newValue);
    if (newValue === 3) {
      setDocLoader(true);
      handleGetQuote();
    }
  };

  // Horizontal
  const [valueX, setValueX] = useState(0);

  const handleChangeX = (event, newValue) => {
    setValueX(newValue);
  };

  const handleChangeIndex = index => {
    setValueX(index);
  };
  const [isFullScreen, setIsFullScreen] = useState(false);

  useEffect(() => {
    document.addEventListener('fullscreenchange', handleFullScreenChange);

    return () => {
      document.removeEventListener('fullscreenchange', handleFullScreenChange);
    };
  }, []);

  const handleFullScreenChange = () => {
    setIsFullScreen(document.fullscreenElement !== null);
  };

  const removeTableCss = finalRes => {
    const regexPattern = /<style[^>]*>([\s\S]*?)<\/style>/gi;

    // Remove table styles including borders
    const updatedHtml = finalRes.replace(regexPattern, (match, styles) => {
      const stylesWithoutTable = styles.replace(
        /(?:table|td|th)\s*\{[^}]*\}/gi,
        ''
      );
      return `<style>${stylesWithoutTable} table { font-size: 12px; } td { padding: 10px; }</style>`;
    });
    return updatedHtml;
  };

  const handleCorresHistory = apiRes => {
    // Regex pattern to capture and replace font-size in table styles
    const fontSizeToUpdate = removeTableCss(apiRes);

    return fontSizeToUpdate;

    // removeTableCss(updatedHtml);
  };

  const handlePDFPrintClose = () => {
    setOpenPrintPDfDialog(false);
    // setNumberOfPrintsColmnVise(1);
  };

  const hanldeCloseLabels = () => {
    setOpenLabelsDialog(false);
    setOpenPrintPDfDialogData('');
    setNumberOfPrints(1);
    setNumberOfPrintsColmnVise(1);
    setSelectedPrintOption(1);
  };
  // const generatePDF = async () => {
  //   const element = document.getElementById('pdf-content');

  //   const pageSize = {
  //     width: 900,
  //     height: 1150
  //   };

  //   const pdfOptions = {
  //     // margin: 1,
  //     filename: 'TMS Bill Of Lading.pdf',
  //     // filename: 'label.pdf',
  //     // image: { type: 'jpeg', quality: 1.0 },
  //     html2canvas: {
  //       scale: 4, // Adjust scale as needed
  //       logging: true // Enable logging if needed
  //     },
  //     jsPDF: {
  //       unit: 'pt',
  //       format: [pageSize.width, pageSize.height],
  //       // format: 'a4',
  //       orientation: 'portrait'
  //     }
  //   };

  //   await html2pdf(element, pdfOptions);
  // };
  const generatePackagingSlipPdf = async () => {
    const element = document.getElementById('pdf-content');

    const pageSize = {
      width: 800,
      height: 1050
    };

    const pdfOptions = {
      // margin: 1,
      filename: 'TMS Packaging Slip.pdf',
      // filename: 'label.pdf',
      // image: { type: 'jpeg', quality: 1.0 },
      html2canvas: {
        scale: 6, // Adjust scale as needed
        logging: true // Enable logging if needed
      },
      jsPDF: {
        unit: 'pt',
        format: [pageSize.width, pageSize.height],
        // format: 'a4',
        orientation: 'portrait'
      }
    };

    await html2pdf(element, pdfOptions);
  };
  const formatTimeTo12Hour = time24 => {
    if (time24) {
      const [hour, minute] = time24?.split(':');
      const hourInt = parseInt(hour, 10);
      const ampm = hourInt >= 12 ? 'PM' : 'AM';
      const hour12 = hourInt % 12 || 12;
      return `${hour12}:${minute} ${ampm}`;
    } else return null;
  };

  const handlePackagingSlip = () => {
    setOpenPDfPackagingSlip(true);
  };

  const handlePdfPackagingClose = () => {
    setOpenPDfPackagingSlip(false);
  };

  // const generatePDF = async (cName, pgWidth, pgHeight, fileName) => {
  //   const element = document.getElementById('pdf-content');
  //   const widthInPoints = 4 * 72; // 4 inches to points
  //   const heightInPoints =
  //     numberOfPrintsColmnVise === 1
  //       ? 6.1 * 72
  //       : numberOfPrintsColmnVise === 2
  //       ? 6.05 * 72
  //       : 6.01 * 72;
  //   const pageSize = {
  //     width: fileName === 'bol' ? pgWidth : widthInPoints,
  //     height: fileName === 'bol' ? pgHeight : heightInPoints
  //   };

  //   const pdfOptions = {
  //     // margin: 1,
  //     filename: `${cName}_${fileName}.pdf`,
  //     // filename: 'label.pdf',
  //     // image: { type: 'jpeg', quality: 1.0 },
  //     html2canvas: {
  //       scale: 3, // Adjust scale as needed
  //       logging: true // Enable logging if needed
  //     },
  //     jsPDF: {
  //       unit: 'pt',
  //       format: [pageSize.width, pageSize.height],
  //       // format: 'a4',
  //       orientation: 'portrait'
  //     }
  //   };

  //   await html2pdf(element, pdfOptions);
  // };

  const generatePDF = async (cName, pgWidth, pgHeight, fileName) => {
    const element = document.getElementById('pdf-content');

    if (fileName !== 'bol') {
      // Your Previous Code
      const widthInPoints = 4 * 72; // 4 inches to points
      const heightInPoints =
        numberOfPrintsColmnVise === 1
          ? 6.1 * 72
          : numberOfPrintsColmnVise === 2
          ? 6.05 * 72
          : 6.01 * 72;

      const pageSize = {
        width: widthInPoints,
        height: heightInPoints
      };

      const pdfOptions = {
        filename: `${cName}_${fileName}.pdf`,
        html2canvas: {
          scale: 3,
          logging: true
        },
        jsPDF: {
          unit: 'pt',
          format: [pageSize.width, pageSize.height],
          orientation: 'portrait'
        }
      };

      await html2pdf(element, pdfOptions);
    } else {
      // New Dynamic Code for Other Cases
      const element = document.getElementById('pdf-content');

      // Measure the height of the content dynamically
      const contentHeight = element.scrollHeight; // Get actual content height
      const heightInPoints = contentHeight - (contentHeight * 25) / 100;

      const pageSize = {
        width: pgWidth, // Default 4 inches in points
        height: heightInPoints // Dynamic height
      };
      console.log(pageSize, 'pageSize');
      const pdfOptions = {
        filename: `${cName}_${fileName}.pdf`,
        html2canvas: {
          scale: 3,
          logging: false
        },
        pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
        jsPDF: {
          unit: 'pt',
          format: [pageSize.width, pageSize.height],
          orientation: 'portrait'
        }
      };

      await html2pdf(element, pdfOptions);
    }
  };

  const printData = rowData => {
    GetShipmentDetails(rowData.shipmentId)
      .then(res => {
        if (res.status === 200) {
          if (rowData.shipmentType === 'Parcel') {
            window.open(rowData.dispatchInput1, '_blank');
          } else {
            rowData.details = res.data.data;
            setOpenLabelsDialog(true);
            setOpenPrintPDfDialogData(rowData);
          }
        }
      })
      .catch(err => ErrorToast(err?.message));
  };

  const handleChangeNoOfPrints = e => {
    setNumberOfPrintsColmnVise(0);
    setNumberOfPrints(0);

    // Update the states based on the selected value
    const value = parseInt(e.target.value, 10);
    setSelectedPrintOption(value);

    switch (value) {
      case 1:
        setNumberOfPrintsColmnVise(1);
        setNumberOfPrints(1);
        break;
      case 2:
        setNumberOfPrintsColmnVise(2);
        setNumberOfPrints(1);
        break;
      case 4:
        setNumberOfPrintsColmnVise(4);
        setNumberOfPrints(1);
        break;
      case 6:
        setNumberOfPrintsColmnVise(6);
        setNumberOfPrints(1);
        break;
      default:
        break;
    }
  };

  const convertMetersToMiles = meters => {
    if (typeof meters !== 'number' || meters < 0) {
      throw new Error('Please provide a valid non-negative number for meters.');
    }

    const MILES_IN_ONE_METER = 0.000621371; // 1 meter = 0.000621371 miles
    return meters * MILES_IN_ONE_METER;
  };

  return (
    <div className='d-flex ' style={{ justifyContent: 'center' }}>
      {/* <ToastContainer
        position='top-center'
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      /> */}
      <Box
        sx={{
          // bgcolor: 'background.paper',
          // backgroundColor: 'red',
          display: 'flex',
          width: '100%',
          borderRadius: '5px',
          // marginTop: -20
          p: 3,
          height: 'auto'
        }}
      >
        <Dialog
          fullWidth
          maxWidth='md'
          minWidth='xs'
          sx={{
            '& .MuiDialog-paper': {
              minWidth: '6.2in',
              maxWidth: '6.2in',
              height: '90vh'
            }
          }}
          // sx={{ minWidth: 80, minHeight: '10vh', height: '90vh' }}
          open={openLabelsDialog}
          onClose={hanldeCloseLabels}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogTitle id='alert-dialog-title'>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div>{openPrintPDfDialogData.carrierName} labels</div>
              <div>
                <CloseIcon
                  sx={{ cursor: 'pointer' }}
                  onClick={hanldeCloseLabels}
                />
              </div>
            </div>
          </DialogTitle>
          <DialogContent>
            <DialogContentText
              sx={{ display: 'flex', justifyContent: 'center' }}
              id='alert-dialog-description'
            >
              <div
                // className='print-section'
                ref={contentRef}
                id='pdf-content'
                style={{
                  padding: 1
                  // border: 'red 1px solid'
                }}
              >
                {[...Array(numberOfPrintsColmnVise)].map((items, oindex) => (
                  <>
                    <div
                      style={{
                        minWidth: '4in',
                        maxWidth: '4in',
                        minHeight: '6in',
                        maxHeight: '6in',
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-evenly',
                        // border: '1px solid red',
                        overflow: 'hidden'
                        // borderRadius: 5,
                        // padding: 2,
                        // marginTop: 10
                      }}
                    >
                      {openPrintPDfDialogData &&
                        [...Array(numberOfPrints)].map((_, index) => (
                          <div
                            key={index}
                            style={{
                              // border: '1px solid black',
                              // padding: '10px',
                              // marginBottom: '15px',
                              pageBreakAfter: 'always'
                            }}
                            className='p-2 d-flex flex-column w-100'
                          >
                            <div className='border border-dark border-2 p-0 px-1 py-1'>
                              <div className='labels-label '>From:</div>
                              <div className='labels-value '>
                                {openPrintPDfDialogData.originCompany}
                              </div>
                              <div className='labels-value '>
                                {openPrintPDfDialogData.originAddress}{' '}
                                {rowData?.originAddress2 &&
                                  `, ${rowData?.originAddress2}`}
                              </div>
                              <div className='labels-value'>
                                {openPrintPDfDialogData.originCity +
                                  ', ' +
                                  openPrintPDfDialogData.originState +
                                  ', ' +
                                  openPrintPDfDialogData.originZipCode}
                              </div>
                            </div>

                            <div className='border border-dark border-2 border-top-0 p-0 px-1 py-1'>
                              <div className='labels-label '>To:</div>
                              <div className='labels-value '>
                                {openPrintPDfDialogData.destinationCompany}
                              </div>
                              <div className='labels-value '>
                                {openPrintPDfDialogData.destinationAddress}{' '}
                                {rowData?.destinationAddress2 &&
                                  `, ${rowData?.destinationAddress2}`}
                              </div>
                              <div className='labels-value'>
                                {openPrintPDfDialogData.destinationCity +
                                  ', ' +
                                  openPrintPDfDialogData.destinationState +
                                  ', ' +
                                  openPrintPDfDialogData.destinationZipCode}
                              </div>
                            </div>

                            <div className='border border-dark border-2 border-top-0 p-0 px-1 py-1'>
                              <div
                                className='d-flex align-items-center justify-content-center'
                                style={{ textAlign: 'left' }}
                              >
                                <span
                                  className='labels-label'
                                  style={{ fontSize: 20 }}
                                >
                                  PRO#{' '}
                                </span>
                                <span
                                  className='labels-value'
                                  style={{
                                    fontSize: 20,
                                    fontWeight: 'bold',
                                    color: 'black'
                                  }}
                                >
                                  {rowData?.proNumber}
                                </span>
                              </div>
                              {openPrintPDfDialogData.proNumber && (
                                <div className='d-flex justify-content-center w-100'>
                                  <Barcode
                                    margin={1}
                                    displayValue={false}
                                    height={40}
                                    fontSize={15}
                                    width={2}
                                    value={openPrintPDfDialogData.proNumber}
                                  />
                                </div>
                              )}
                            </div>

                            <div className='border border-dark border-2 border-top-0 p-0 px-1 py-1'>
                              <span className='labels-label mb-1'>BOL#:</span>
                              <span className='labels-value'>
                                {openPrintPDfDialogData.bolNumber}
                              </span>
                            </div>

                            <div className='border border-dark border-2 border-top-0 p-0 px-1 py-1'>
                              <span className='labels-label mb-1'>
                                Pickup Date:
                              </span>
                              <span className='labels-value'>
                                {openPrintPDfDialogData.pickupDate}
                              </span>
                            </div>

                            <div className='border border-dark border-2 border-top-0 p-0 px-1 py-1'>
                              <span className='labels-label mb-1'>
                                Handling Units#:
                              </span>
                              <span className='labels-value'>
                                {openPrintPDfDialogData?.details?.reduce(
                                  (sum, item) => sum + item.units,
                                  0
                                )}
                              </span>
                            </div>

                            <div className='border border-dark border-2 border-top-0 p-0 px-1 py-1'>
                              <span className='labels-label mb-1'>
                                # of Pieces:
                              </span>
                              <span className='labels-value'>
                                {openPrintPDfDialogData?.details?.reduce(
                                  (sum, item) => sum + item.pieces,
                                  0
                                )}
                              </span>
                            </div>

                            <div className='border border-dark border-2 border-top-0 p-0 px-1 py-1'>
                              <span className='labels-label mb-1'>
                                Shipment #:
                              </span>
                              <span className='labels-value'>
                                {openPrintPDfDialogData.soNumber}
                              </span>
                            </div>

                            <div className='border border-dark border-2 border-top-0 p-0 px-1 py-1'>
                              <span className='labels-label mb-1'>PO#:</span>
                              <span className='labels-value'>
                                {openPrintPDfDialogData.clientPONumber}
                              </span>
                            </div>

                            <div className='border border-dark border-2 border-top-0 p-0 px-1 py-1'>
                              <div
                                className='labels-label'
                                style={{ fontSize: '18px' }}
                              >
                                Carrier: {openPrintPDfDialogData.carrierName}
                              </div>

                              <img
                                style={{
                                  objectFit: 'contain',
                                  width: 'auto',
                                  maxWidth: '80%',
                                  height: '0.9in'
                                }}
                                alt={openPrintPDfDialogData.carrierName}
                                // className='border'
                                src={
                                  openPrintPDfDialogData.carrierLogo
                                    ? base_logo_url +
                                      openPrintPDfDialogData.carrierLogo
                                    : NoLogo
                                }
                              />
                            </div>
                          </div>
                        ))}

                      {/* {parseInt(numberOfPrintsColmnVise) > 1 &&
                        oindex === 0 && <div className='page-break5'></div>}
                      {parseInt(numberOfPrintsColmnVise) > 2 &&
                        oindex === 1 && <div className='page-break5'></div>} */}
                    </div>
                  </>
                ))}
              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions
            sx={{
              // position: 'sticky',
              // bottom: 0,
              // marginTop: 10,
              // backgroundColor: 'white', // Ensure it doesn’t overlap content
              // zIndex: 1,
              display: 'flex',
              justifyContent: 'space-between'
              // padding: 2
            }}
          >
            <div>
              <label style={{ fontSize: '13' }} htmlFor='printSelect'>
                Number of Prints:
              </label>
              <select
                className='mx-1'
                id='printSelect'
                value={selectedPrintOption}
                onChange={e => {
                  handleChangeNoOfPrints(e);
                }}
              >
                <option value={1}>1</option>
                <option value={2}>2</option>
                <option value={4}>4</option>
                <option value={6}>6</option>
              </select>
            </div>
            <Button
              size='small'
              variant='contained'
              onClick={() =>
                generatePDF(
                  openPrintPDfDialogData.carrierName,
                  50,
                  750,
                  'labels'
                )
              }
            >
              Generate PDF
            </Button>
            <Button
              size='small'
              variant='contained'
              onClick={() => handlePrint()} // Trigger print on click
            >
              Print
            </Button>
          </DialogActions>
        </Dialog>
        {/* BOL Dialog Box */}
        <Dialog
          fullWidth
          maxWidth='md'
          minWidth='xs'
          sx={{ '& .MuiDialog-paper': { minWidth: '1050px' } }}
          open={openPrintPDfDialog}
          onClose={handlePDFPrintClose}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogTitle id='alert-dialog-title'>
            <div style={{ display: 'flex', justifyContent: 'end' }}>
              {/* <div>BILL OF LADING </div> */}
              <div>
                <CloseIcon
                  sx={{ cursor: 'pointer' }}
                  onClick={handlePDFPrintClose}
                />
              </div>
            </div>
          </DialogTitle>
          <DialogContent>
            <DialogContentText ref={contentRef} id='alert-dialog-description'>
              <div
                id='pdf-content'
                style={{
                  minWidth: '100%',
                  minHeight: '100%',
                  padding: 30,
                  paddingLeft: 40,
                  paddingRight: 40
                }}
              >
                {/* 1st page  */}

                <div style={{ marginBottom: 10 }}>
                  <svg
                    width='202'
                    height='37'
                    class='my-1'
                    viewBox='0 0 356 73'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      fill-rule='evenodd'
                      clip-rule='evenodd'
                      d='M19.7868 0.000359717L13.4229 6.36432L28.3075 21.2489C32.6032 25.5447 39.568 25.5447 43.8638 21.2489L58.7488 6.36398L52.3848 1.52588e-05L37.4998 14.885C36.7188 15.666 35.4525 15.666 34.6714 14.885L19.7868 0.000359717Z'
                      fill='#3361FF'
                    />
                    <path
                      fill-rule='evenodd'
                      clip-rule='evenodd'
                      d='M72.1715 19.7867L65.8076 13.4227L50.923 28.3073C46.6272 32.6031 46.6272 39.5679 50.923 43.8637L65.8079 58.7486L72.1719 52.3847L57.2869 37.4997C56.5059 36.7187 56.5059 35.4524 57.2869 34.6713L72.1715 19.7867Z'
                      fill='#3361FF'
                    />
                    <path
                      fill-rule='evenodd'
                      clip-rule='evenodd'
                      d='M19.7868 72.1713L13.4229 65.8073L28.3075 50.9227C32.6032 46.627 39.568 46.627 43.8638 50.9227L58.7487 65.8077L52.3848 72.1716L37.4998 57.2867C36.7188 56.5056 35.4525 56.5057 34.6714 57.2867L19.7868 72.1713Z'
                      fill='#3361FF'
                    />
                    <path
                      fill-rule='evenodd'
                      clip-rule='evenodd'
                      d='M0.000342659 19.7867L6.3643 13.4227L21.2489 28.3074C25.5447 32.6031 25.5447 39.5679 21.2489 43.8637L6.36396 58.7486L-1.70308e-06 52.3847L14.8849 37.4997C15.666 36.7187 15.666 35.4524 14.8849 34.6713L0.000342659 19.7867Z'
                      fill='#3361FF'
                    />
                    <path
                      d='M94.7104 42.8213C95.7934 43.1905 96.9749 43.4859 98.2548 43.7074C99.5593 43.9043 100.852 44.0028 102.131 44.0028C103.879 44.0028 105.171 43.929 106.008 43.7813C106.87 43.609 107.436 43.3505 107.706 43.0059C107.977 42.6614 108.113 42.2183 108.113 41.6768C108.113 41.2092 108.014 40.84 107.817 40.5692C107.62 40.2985 107.239 40.0892 106.673 39.9416C106.107 39.7693 105.27 39.6339 104.162 39.5354L101.725 39.3139C99.9039 39.1416 98.464 38.7601 97.4056 38.1694C96.3718 37.5787 95.6334 36.791 95.1904 35.8065C94.772 34.7973 94.5628 33.5913 94.5628 32.1883C94.5628 30.5146 94.895 29.1608 95.5596 28.127C96.2488 27.0933 97.3564 26.3426 98.8824 25.8749C100.408 25.3826 102.439 25.1365 104.974 25.1365C108.273 25.1365 110.992 25.5672 113.134 26.4287L113.023 31.4499L112.912 31.5976C110.475 30.7361 107.928 30.3053 105.27 30.3053C103.99 30.3053 103.005 30.3792 102.316 30.5269C101.627 30.6499 101.147 30.8592 100.876 31.1545C100.605 31.4499 100.47 31.8683 100.47 32.4098C100.47 32.9513 100.556 33.3574 100.728 33.6282C100.925 33.8989 101.307 34.1081 101.873 34.2558C102.439 34.3789 103.264 34.502 104.347 34.625L106.673 34.8835C108.642 35.105 110.155 35.4988 111.214 36.0649C112.272 36.631 112.998 37.3941 113.392 38.354C113.811 39.2893 114.02 40.4338 114.02 41.7876C114.02 43.4367 113.663 44.815 112.949 45.9227C112.26 47.0057 111.128 47.8179 109.552 48.3594C107.977 48.9009 105.873 49.1716 103.239 49.1716C101.516 49.1716 99.9654 49.0855 98.5871 48.9132C97.2087 48.7163 95.8673 48.4579 94.5628 48.1379V42.9321L94.7104 42.8213ZM123.635 48.8394H117.727V25.4688H123.635V34.4035H132.496V25.4688H138.403V48.8394H132.496V39.2032H123.635V48.8394ZM148.729 48.8394H142.822V25.4688H148.729V48.8394ZM159.077 48.8394H153.169V25.4688H163.581C165.919 25.4688 167.79 25.7518 169.193 26.3179C170.596 26.8841 171.605 27.8071 172.22 29.087C172.836 30.3669 173.143 32.1021 173.143 34.2927C173.143 36.3603 172.836 38.0463 172.22 39.3508C171.605 40.6307 170.596 41.5784 169.193 42.1937C167.79 42.809 165.919 43.1167 163.581 43.1167H159.077V48.8394ZM162.621 30.3053H159.077V38.2801H162.621C164.369 38.2801 165.538 37.9848 166.129 37.3941C166.719 36.8033 167.015 35.7696 167.015 34.2927C167.015 32.8898 166.719 31.8806 166.129 31.2653C165.538 30.6253 164.369 30.3053 162.621 30.3053ZM192.149 48.8394V30.453H185.504V25.4688H204.702V30.453H198.057V48.8394H192.149ZM207.288 48.8394V25.4688H224.641V30.2684H213.195V34.6989H223.127V39.4985H213.195V44.0397H224.641V48.8394H207.288ZM245.013 43.7813V48.4332C243.832 48.6794 242.675 48.864 241.543 48.987C240.411 49.1101 239.069 49.1716 237.519 49.1716C235.525 49.1716 233.839 48.9994 232.461 48.6548C231.107 48.3102 230.011 47.7071 229.175 46.8457C228.362 45.9596 227.772 44.7166 227.402 43.1167C227.033 41.5168 226.849 39.4616 226.849 36.951C226.849 34.5389 227.033 32.5575 227.402 31.0068C227.772 29.4562 228.362 28.2624 229.175 27.4256C230.011 26.5641 231.107 25.9734 232.461 25.6534C233.839 25.3088 235.525 25.1365 237.519 25.1365C239.069 25.1365 240.411 25.198 241.543 25.3211C242.675 25.4196 243.832 25.6042 245.013 25.8749V30.6745L244.903 30.7484C243.869 30.5023 242.872 30.33 241.912 30.2315C240.952 30.1084 239.771 30.0469 238.368 30.0469C237.236 30.0469 236.3 30.1331 235.562 30.3053C234.848 30.453 234.282 30.7607 233.864 31.2284C233.445 31.696 233.15 32.3852 232.977 33.2959C232.83 34.2066 232.756 35.425 232.756 36.951C232.756 38.5509 232.83 39.8431 232.977 40.8276C233.15 41.7876 233.445 42.5137 233.864 43.0059C234.282 43.4982 234.848 43.8305 235.562 44.0028C236.3 44.1751 237.236 44.2612 238.368 44.2612C239.746 44.2612 240.915 44.2243 241.875 44.1505C242.86 44.052 243.844 43.8797 244.829 43.6336L245.013 43.7813ZM254.046 48.8394H248.138V25.4688H254.046V34.4035H262.907V25.4688H268.814V48.8394H262.907V39.2032H254.046V48.8394ZM290.209 48.8394H284.302V25.4688H294.713C297.051 25.4688 298.922 25.7518 300.325 26.3179C301.728 26.8841 302.737 27.8071 303.353 29.087C303.968 30.3669 304.276 32.1021 304.276 34.2927C304.276 36.3603 303.968 38.0463 303.353 39.3508C302.737 40.6307 301.728 41.5784 300.325 42.1937C298.922 42.809 297.051 43.1167 294.713 43.1167H290.209V48.8394ZM293.753 30.3053H290.209V38.2801H293.753C295.501 38.2801 296.67 37.9848 297.261 37.3941C297.851 36.8033 298.147 35.7696 298.147 34.2927C298.147 32.8898 297.851 31.8806 297.261 31.2653C296.67 30.6253 295.501 30.3053 293.753 30.3053ZM313.32 48.8394H307.413V25.4688H318.563C321.492 25.4688 323.621 26.1333 324.95 27.4625C326.304 28.767 326.981 30.6992 326.981 33.259C326.981 35.1788 326.501 36.8279 325.541 38.2063C324.581 39.56 323.313 40.4092 321.738 40.7538L321.701 40.8646C322.316 41.2584 322.993 41.9106 323.732 42.8213C324.47 43.732 325.196 44.7289 325.91 45.8119C326.648 46.8703 327.301 47.8671 327.867 48.8024V48.8394H321L317.012 42.9321C316.668 42.4152 316.385 42.046 316.163 41.8245C315.966 41.603 315.72 41.4676 315.425 41.4184C315.154 41.3691 314.711 41.3445 314.095 41.3445H313.32V48.8394ZM317.603 30.2684H313.32V36.5449H317.603C318.834 36.5449 319.683 36.2988 320.15 35.8065C320.643 35.3142 320.889 34.5143 320.889 33.4067C320.889 32.299 320.643 31.4991 320.15 31.0068C319.683 30.5146 318.834 30.2684 317.603 30.2684ZM330.471 37.1356C330.471 34.1574 330.803 31.7945 331.468 30.0469C332.157 28.2993 333.326 27.044 334.975 26.281C336.649 25.518 338.975 25.1365 341.953 25.1365C344.193 25.1365 346.051 25.3457 347.528 25.7641C349.005 26.1826 350.174 26.8594 351.035 27.7948C351.897 28.7301 352.5 29.9731 352.845 31.5237C353.214 33.0498 353.398 34.9204 353.398 37.1356C353.398 39.3754 353.214 41.2707 352.845 42.8213C352.5 44.3474 351.897 45.5781 351.035 46.5134C350.174 47.4487 349.005 48.1256 347.528 48.544C346.051 48.9624 344.193 49.1716 341.953 49.1716C339.713 49.1716 337.855 48.9624 336.378 48.544C334.901 48.1256 333.732 47.4487 332.871 46.5134C332.009 45.5781 331.394 44.3474 331.025 42.8213C330.655 41.2707 330.471 39.3754 330.471 37.1356ZM341.953 44.0028C343.528 44.0028 344.71 43.8059 345.497 43.4121C346.285 43.0183 346.814 42.3291 347.085 41.3445C347.356 40.3354 347.491 38.9324 347.491 37.1356C347.491 35.3634 347.356 33.9851 347.085 33.0005C346.814 32.016 346.285 31.3268 345.497 30.933C344.71 30.5146 343.528 30.3053 341.953 30.3053C340.402 30.3053 339.221 30.5146 338.409 30.933C337.621 31.3268 337.08 32.016 336.784 33.0005C336.513 33.9851 336.378 35.3634 336.378 37.1356C336.378 38.9324 336.513 40.3354 336.784 41.3445C337.08 42.3291 337.621 43.0183 338.409 43.4121C339.221 43.8059 340.402 44.0028 341.953 44.0028Z'
                      fill='#354463'
                    />
                  </svg>
                </div>
                <div
                  style={{
                    display: 'flex',
                    width: '100%',
                    border: '0.5px solid black',
                    marginTop: 10
                  }}
                >
                  {/* lefthalf */}
                  <div
                    style={{
                      fontSize: '20px',
                      borderRight: '0.5px solid black',
                      flex: 1,
                      padding: 10,
                      display: 'flex', // Make the parent a flex container
                      justifyContent: 'space-between', // Center horizontally
                      alignItems: 'center'
                      // alignSelf: 'center'
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between'
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'space-between'
                        }}
                      >
                        <div style={{ marginRight: 10 }}>
                          <span className='bol-label'>Carrier:</span>
                          {/* <br /> */}
                          <span className='bol-value'>
                            {rowData?.carrierName}
                          </span>
                        </div>
                        <div style={{ marginRight: 10 }}>
                          <span className='bol-label'>Quote #</span>
                          <span className='bol-value'>
                            {rowData?.quoteNumber}
                          </span>
                        </div>

                        <div style={{ marginRight: 10 }}>
                          <span className='bol-label'>Pickup #</span>
                          <span className='bol-value'>
                            {rowData?.pickupNumber}
                          </span>
                        </div>

                        <div style={{ marginRight: 10 }}>
                          <span className='bol-label'>Service:</span>
                          <span className='bol-value'>
                            {rowData?.serviceType}
                          </span>
                        </div>
                      </div>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'space-between'
                        }}
                      >
                        {/* <div>
                          <span className='bol-label'>
                            Requested Pickup Date:{' '}
                          </span>
                          <br />
                          <span className='bol-value'>
                            {rowData.pickupDate}
                          </span>
                        </div> */}
                        {/* {(rowData.shipmentStatus === 'InTransit' ||
                          rowData.shipmentStatus === 'Delivered') && ( */}
                        <div>
                          <span className='bol-label'>Pickup Date: </span>
                          {/* <br /> */}
                          <span className='bol-value'>
                            {rowData.pickupDate}
                          </span>
                        </div>
                        {/* )} */}

                        <div>
                          <span className='bol-label'>SO #</span>
                          <span className='bol-value'>{rowData?.soNumber}</span>
                        </div>

                        <div>
                          <span className='bol-label'>PO #</span>
                          <span className='bol-value'>
                            {rowData?.clientPONumber}
                          </span>
                        </div>

                        <div>
                          <span className='bol-label'>BOL#</span>
                          <span className='bol-value'>
                            {rowData?.bolNumber}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* righthalf */}
                  <div
                    style={{
                      flex: 1,
                      textAlign: 'center',
                      padding: 10
                    }}
                  >
                    <div
                      style={{
                        textAlign: 'center'
                      }}
                      className='d-flex flex-column'
                    >
                      <div
                        className='d-flex align-items-center justify-content-center'
                        style={{ textAlign: 'left' }}
                      >
                        <span className='bol-label' style={{ fontSize: 40 }}>
                          PRO#{' '}
                        </span>
                        <span
                          className='bol-value'
                          style={{
                            fontSize: 40,
                            fontWeight: 'bold',
                            color: 'black'
                          }}
                        >
                          {rowData?.proNumber}
                        </span>
                      </div>
                      <div style={{ textAlign: 'center', width: '100%' }}>
                        <Barcode
                          displayValue={false}
                          height={75}
                          fontSize={35}
                          fontOptions='bold'
                          width={3}
                          value={rowData?.proNumber}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* origin destination */}
                <div
                  style={{
                    display: 'flex',
                    width: '100%',
                    border: '0.5px solid black',
                    borderTop: 0
                  }}
                >
                  {/* lefthalf */}
                  <div
                    style={{
                      borderRight: '0.5px solid black',
                      flex: 1,
                      padding: 0
                    }}
                    className=''
                  >
                    <div
                      style={{
                        borderBottom: '0.5px solid black',
                        textAlign: 'center',
                        backgroundColor: 'rgb(222 222 222)',
                        width: '100%'
                      }}
                      className='bol-label py-1'
                    >
                      Shipper
                    </div>

                    <div style={{ padding: 10 }}>
                      <div className='bol-value'>{rowData?.originCompany}</div>
                      <div className='bol-value'>
                        {rowData?.originAddress}{' '}
                        {rowData?.originAddress2 &&
                          `, ${rowData?.originAddress2}`}
                      </div>
                      <div className='bol-value'>
                        {rowData?.originCity}, {rowData?.originState},{' '}
                        {rowData?.originZipCode}
                      </div>
                      <div>
                        <span className='bol-label'>Shipping Department:</span>
                        <span className='bol-value'>
                          {formatPhoneNumber(rowData?.originContactPhone)}
                          <br />
                          {rowData?.originContactEmail}
                        </span>
                      </div>
                      <div>
                        <span className='bol-label'>Pickup Hours:</span>
                        <span className='bol-value'>
                          {rowData?.pickupStartTime} - {rowData?.pickupEndTime}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* righthalf */}
                  <div
                    style={{
                      flex: 1,
                      padding: 0
                    }}
                    className=''
                  >
                    <div
                      style={{
                        borderBottom: '0.5px solid black',
                        textAlign: 'center',
                        backgroundColor: 'rgb(222 222 222)',
                        width: '100%'
                      }}
                      className='bol-label py-1'
                    >
                      Consignee
                    </div>

                    <div style={{ padding: 10 }}>
                      <div className='bol-value'>
                        {rowData?.destinationCompany}
                      </div>
                      <div className='bol-value'>
                        {rowData?.destinationAddress}{' '}
                        {rowData?.destinationAddress2 &&
                          `, ${rowData?.destinationAddress2}`}
                      </div>
                      <div className='bol-value'>
                        {rowData?.destinationCity}, {rowData?.destinationState},{' '}
                        {rowData?.destinationZipCode}
                      </div>
                      <div>
                        <span className='bol-label'>Shipping Department:</span>
                        <span className='bol-value'>
                          {formatPhoneNumber(rowData?.destinationContactPhone)}
                          <br />
                          {rowData?.destinationContactEmail}
                        </span>
                      </div>
                      <div>
                        <span className='bol-label'>Delivery Hours:</span>
                        <span className='bol-value'>
                          {rowData?.deliverStartTime} -{' '}
                          {rowData?.deliverEndTime}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* terminal info */}
                <div
                  style={{
                    display: 'flex',
                    width: '100%',
                    border: '0.5px solid black',
                    borderTop: 0
                  }}
                >
                  {/* lefthalf */}
                  <div
                    style={{
                      borderRight: '0.5px solid black',
                      flex: 1,
                      padding: 0
                    }}
                    className=''
                  >
                    <div
                      style={{
                        borderBottom: '0.5px solid black',
                        textAlign: 'center',
                        backgroundColor: 'rgb(222 222 222)',
                        width: '100%'
                      }}
                      className='bol-label py-1'
                    >
                      Origin Terminal
                    </div>

                    <div style={{ padding: 10 }}>
                      {rowData?.originTerminalContact && (
                        <div>
                          <span className='bol-label'>Contact Person:</span>
                          <span className='bol-value'>
                            {rowData?.originTerminalContact}
                          </span>
                        </div>
                      )}
                      {rowData?.originTerminalContactPhone && (
                        <div>
                          <span className='bol-label'>Phone:</span>
                          <span className='bol-value'>
                            {formatPhoneNumber(
                              rowData?.originTerminalContactPhone
                            )}
                          </span>
                        </div>
                      )}
                      {rowData?.originTerminalContantEmail && (
                        <div>
                          <span className='bol-label'>Email:</span>
                          <span className='bol-value'>
                            {rowData?.originTerminalContantEmail}
                          </span>
                        </div>
                      )}
                      {(rowData?.originTerminalAddress ||
                        rowData?.originTerminalAddress2) && (
                        <div>
                          <span className='bol-label'>Street Address:</span>
                          <span className='bol-value'>
                            {rowData?.originTerminalAddress}{' '}
                            {rowData?.originTerminalAddress2 &&
                              `,${rowData?.originTerminalAddress2}`}
                          </span>
                        </div>
                      )}
                      {rowData?.originTerminalCity && (
                        <div>
                          <span className='bol-label'>Address:</span>
                          <span className='bol-value'>
                            {rowData?.originTerminalCity},{' '}
                            {rowData?.originTerminalState} ,{' '}
                            {rowData?.originTerminalPostalCode},{' '}
                            {rowData?.originTerminalCountry}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* righthalf */}
                  <div
                    style={{
                      flex: 1,
                      padding: 0
                    }}
                    className=''
                  >
                    <div
                      style={{
                        borderBottom: '0.5px solid black',
                        textAlign: 'center',
                        backgroundColor: 'rgb(222 222 222)',
                        width: '100%'
                      }}
                      className='bol-label py-1'
                    >
                      Destination Terminal
                    </div>

                    <div style={{ padding: 10 }}>
                      {rowData?.destinationTerminalContact && (
                        <div>
                          <span className='bol-label'>Contact Person:</span>

                          <span className='bol-value'>
                            {rowData?.destinationTerminalContact}
                          </span>
                        </div>
                      )}
                      {rowData?.destinationTerminalContactPhone && (
                        <div>
                          <span className='bol-label'>Phone:</span>

                          <span className='bol-value'>
                            {formatPhoneNumber(
                              rowData?.destinationTerminalContactPhone
                            )}
                          </span>
                        </div>
                      )}
                      {rowData?.destinationTerminalContantEmail && (
                        <div>
                          <span className='bol-label'>Email:</span>

                          <span className='bol-value'>
                            {rowData?.destinationTerminalContantEmail}
                          </span>
                        </div>
                      )}
                      {(rowData?.destinationTerminalAddress ||
                        rowData?.destinationTerminalAddress2) && (
                        <div>
                          <span className='bol-label'>Street Address:</span>

                          <span className='bol-value'>
                            {rowData?.destinationTerminalAddress}{' '}
                            {rowData?.destinationTerminalAddress2 &&
                              `,${rowData?.destinationTerminalAddress2}`}
                          </span>
                        </div>
                      )}
                      {rowData?.destinationTerminalCity && (
                        <div>
                          <span className='bol-label'>Address:</span>

                          <span className='bol-value'>
                            {rowData?.destinationTerminalCity},{' '}
                            {rowData?.destinationTerminalState} ,{' '}
                            {rowData?.destinationTerminalPostalCode},{' '}
                            {rowData?.destinationTerminalCountry}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div
                  style={{
                    display: 'flex',
                    width: '100%',
                    border: '0.5px solid black',
                    borderTop: 0
                  }}
                >
                  {/* lefthalf */}
                  <div
                    style={{
                      borderRight: '0.5px solid black',
                      flex: 1,
                      padding: 0
                    }}
                    className=''
                  >
                    <div
                      style={{
                        borderBottom: '0.5px solid black',
                        textAlign: 'center',
                        backgroundColor: 'rgb(222 222 222)',
                        width: '100%'
                      }}
                      className='bol-label py-1'
                    >
                      Bill To or REMIT To
                    </div>

                    <div style={{ padding: 10 }}>
                      <div className='bol-value'>
                        {rowData?.carrierBillToCompany}
                      </div>
                      <div className='bol-value'>
                        {rowData?.carrierBillToAddress}{' '}
                        {rowData?.carrierBillToAddress2 &&
                          `,${rowData?.carrierBillToAddress2}`}
                      </div>
                      {(rowData?.carrierBillToCity ||
                        rowData?.carrierBillToState ||
                        rowData?.carrierBillToZip) && (
                        <div className='bol-value'>
                          {rowData?.carrierBillToCity},{' '}
                          {rowData?.carrierBillToState},{' '}
                          {rowData?.carrierBillToZip}
                        </div>
                      )}
                      {(rowData?.carrierBillToContactPhone ||
                        rowData?.carrierBillToContactEmail) && (
                        <div>
                          <span className='bol-label'>
                            Shipping Department:
                          </span>
                          <span className='bol-value'>
                            {formatPhoneNumber(
                              rowData?.carrierBillToContactPhone
                            )}
                            <br />
                            {rowData?.carrierBillToContactEmail}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>

                  <div
                    style={{
                      flex: 1,
                      padding: 0
                    }}
                    className=''
                  >
                    <div
                      style={{
                        borderBottom: '0.5px solid black',
                        textAlign: 'center',
                        backgroundColor: 'rgb(222 222 222)',
                        width: '100%'
                      }}
                      className='bol-label py-1'
                    >
                      Freight Terms
                    </div>

                    <div style={{ padding: 10 }}>
                      <div style={{ textAlign: 'left' }}>
                        <div className='d-flex align-items-center justify-content-between'>
                          <span className='bol-value'>Prepaid</span>
                          <Checkbox
                            disabled
                            {...label}
                            checked={
                              rowData?.freightTerms === 'OutboundPrepaid'
                            }
                          />
                        </div>
                        <div
                          style={{ marginTop: -15 }}
                          className='d-flex align-items-center justify-content-between'
                        >
                          <span className='bol-value'>Collect</span>
                          <Checkbox
                            disabled
                            {...label}
                            checked={rowData?.freightTerms === 'InboundCollect'}
                          />
                        </div>
                        <div
                          style={{ marginTop: -15 }}
                          className='d-flex align-items-center justify-content-between'
                        >
                          <span className='bol-value'>3rd Party</span>
                          <Checkbox
                            disabled
                            {...label}
                            checked={rowData?.freightTerms === 'ThirdParty'}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  style={{
                    display: 'flex',
                    width: '100%',
                    border: '0.5px solid black',
                    borderTop: 0,
                    marginBottom: 20
                  }}
                >
                  {/* lefthalf */}
                  <div
                    style={{
                      borderRight: '0.5px solid black',
                      flex: 1,
                      padding: 0
                    }}
                    className=''
                  >
                    <div
                      style={{
                        borderBottom: '0.5px solid black',
                        textAlign: 'center',
                        backgroundColor: 'rgb(222 222 222)',
                        width: '100%'
                      }}
                      className='bol-label py-1'
                    >
                      Special Instructions
                    </div>

                    <div style={{ padding: 10 }}>
                      <div className='bol-value'>
                        {/* {rowData?.shippingNotes.replace(/<\/?[^>]+(>|$)/g, '')} */}
                        <div
                          dangerouslySetInnerHTML={{
                            __html: rowData?.shippingNotes.replace(
                              /&nbsp;/g,
                              ' '
                            )
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div
                    style={{
                      flex: 1,
                      padding: 0
                    }}
                    className=''
                  >
                    <div
                      style={{
                        borderBottom: '0.5px solid black',
                        textAlign: 'center',
                        backgroundColor: 'rgb(222 222 222)',
                        width: '100%'
                      }}
                      className='bol-label py-1'
                    >
                      Accessorials
                    </div>
                    {rowData?.isHazmat && (
                      <div
                        style={{ margin: '9px' }}
                        className='d-flex align-items-center justify-content-between'
                      >
                        <span>Hazmat</span>
                        <Checkbox
                          disabled
                          {...label}
                          checked={rowData?.isHazmat}
                        />
                      </div>
                    )}

                    {(rowData?.pickupOptionsAccessorial?.inside ||
                      rowData?.pickupOptionsAccessorial?.liftGateServices,
                    rowData?.pickupOptionsAccessorial?.residential,
                    rowData?.pickupOptionsAccessorial?.secureAccess,
                    rowData?.pickupOptionsAccessorial?.limitedAccess,
                    rowData?.pickupOptionsAccessorial?.freezeProtection,
                    rowData?.pickupOptionsAccessorial?.overLength) && (
                      <div>
                        <div style={{ padding: 4 }}>Pickup Services</div>
                        <div style={{ padding: 5 }}>
                          {rowData?.pickupOptionsAccessorial?.inside && (
                            <Chip
                              sx={{ m: 0.4 }}
                              size='small'
                              variant='outlined'
                              label='Inside Pickup'
                              icon={<DoneIcon />}
                            />
                          )}
                          {rowData?.pickupOptionsAccessorial
                            ?.liftGateServices && (
                            <Chip
                              sx={{ m: 0.4 }}
                              size='small'
                              variant='outlined'
                              label='Lift Gate Services'
                              icon={<DoneIcon />}
                            />
                          )}
                          {rowData?.pickupOptionsAccessorial?.residential && (
                            <Chip
                              sx={{ m: 0.4 }}
                              size='small'
                              variant='outlined'
                              label='Resdential Pickup'
                              icon={<DoneIcon />}
                            />
                          )}
                          {rowData?.pickupOptionsAccessorial?.secureAccess && (
                            <Chip
                              sx={{ m: 0.4 }}
                              size='small'
                              variant='outlined'
                              label='Secure Access'
                              icon={<DoneIcon />}
                            />
                          )}
                          {rowData?.pickupOptionsAccessorial?.limitedAccess && (
                            <Chip
                              sx={{ m: 0.4 }}
                              size='small'
                              variant='outlined'
                              label='Limited Access'
                              icon={<DoneIcon />}
                            />
                          )}
                          {rowData?.pickupOptionsAccessorial
                            ?.freezeProtection && (
                            <Chip
                              sx={{ m: 0.4 }}
                              size='small'
                              variant='outlined'
                              label='Freeze Protection'
                              icon={<DoneIcon />}
                            />
                          )}
                          {rowData?.pickupOptionsAccessorial?.overLength && (
                            <Chip
                              sx={{ m: 0.4 }}
                              size='small'
                              variant='outlined'
                              label={`OverLength ${
                                rowData?.pickupOptionsAccessorial
                                  ?.overLengthValue
                                  ? rowData?.pickupOptionsAccessorial
                                      ?.overLengthValue
                                  : ''
                              }`}
                              icon={<DoneIcon />}
                            />
                          )}
                        </div>
                      </div>
                    )}

                    {(rowData?.deliveryOptionAccessorial?.inside ||
                      rowData?.deliveryOptionAccessorial?.liftGateServices,
                    rowData?.deliveryOptionAccessorial?.residential,
                    rowData?.deliveryOptionAccessorial?.secureAccess,
                    rowData?.deliveryOptionAccessorial?.limitedAccess,
                    rowData?.deliveryOptionAccessorial?.callBeforeDelivery) && (
                      <div>
                        <div style={{ padding: 4 }}>Delivery Services</div>
                        <div style={{ padding: 5 }}>
                          {rowData?.deliveryOptionAccessorial?.inside && (
                            <Chip
                              sx={{ m: 0.4 }}
                              size='small'
                              variant='outlined'
                              label='Inside Delivery'
                              icon={<DoneIcon />}
                            />
                          )}
                          {rowData?.deliveryOptionAccessorial
                            ?.liftGateServices && (
                            <Chip
                              sx={{ m: 0.4 }}
                              size='small'
                              variant='outlined'
                              label='Lift Gate Services'
                              icon={<DoneIcon />}
                            />
                          )}
                          {rowData?.deliveryOptionAccessorial?.residential && (
                            <Chip
                              sx={{ m: 0.4 }}
                              size='small'
                              variant='outlined'
                              label='Resdential Delivery'
                              icon={<DoneIcon />}
                            />
                          )}
                          {rowData?.deliveryOptionAccessorial?.secureAccess && (
                            <Chip
                              sx={{ m: 0.4 }}
                              size='small'
                              variant='outlined'
                              label='Secure Access'
                              icon={<DoneIcon />}
                            />
                          )}
                          {rowData?.deliveryOptionAccessorial
                            ?.limitedAccess && (
                            <Chip
                              sx={{ m: 0.4 }}
                              size='small'
                              variant='outlined'
                              label='Limited Access'
                              icon={<DoneIcon />}
                            />
                          )}
                          {rowData?.deliveryOptionAccessorial
                            ?.callBeforeDelivery && (
                            <Chip
                              sx={{ m: 0.4 }}
                              size='small'
                              variant='outlined'
                              label='Call Before Delivery'
                              icon={<DoneIcon />}
                            />
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <CustomTable
                  rowData={viewShipmentsDetails}
                  rowData2={rowData}
                />
                {/* <div className='page-break'></div> */}
              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ display: 'flex', justifyContent: 'center' }}>
            <Button
              size='small'
              variant='contained'
              onClick={() => generatePDF(rowData.carrierName, 850, 1250, 'bol')}
            >
              Generate PDF
            </Button>
          </DialogActions>
        </Dialog>
        {/* Packaging Slip Box */}
        <Dialog
          fullWidth
          maxWidth='md'
          minWidth='xs'
          sx={{ '& .MuiDialog-paper': { minWidth: '850px' } }}
          open={openPDfPackagingSlip}
          onClose={handlePdfPackagingClose}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogTitle id='alert-dialog-title'>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div>Packaging Slip </div>
              <div>
                <CloseIcon
                  sx={{ cursor: 'pointer' }}
                  onClick={handlePdfPackagingClose}
                />
              </div>
            </div>
          </DialogTitle>
          <DialogContent>
            <DialogContentText id='alert-dialog-description'>
              <div
                id='pdf-content'
                style={{
                  minWidth: '100%',
                  minHeight: '100%',
                  padding: 10
                }}
              >
                {/* 1st page  */}
                <div style={{ display: 'flex' }}>
                  {' '}
                  {/* <div style={{ margin: -20 }}>
                    <img
                      alt=''
                      style={{ height: 120 }}
                      src={base_logo_url + AgencyAdminDetails?.userAvatar}
                    />
                  </div> */}
                  {/* <div style={{ marginLeft: 30 }}>
                    <div style={{ fontWeight: 'bold', fontSize: 18 }}>
                      {rowData?.billToCompany}
                    </div>
                    <div>
                      {rowData?.billToZipCode +
                        ' ' +
                        rowData?.billToCity +
                        ' ' +
                        rowData?.billToState}
                    </div>
                    <div>{rowData?.billToAddress}</div>
                    <div>
                      {rowData?.billToContactPhone}{' '}
                      {rowData?.billToContactEmail}
                    </div>
                  </div> */}
                </div>
                <div
                // style={{
                //   // margin: 10
                //   // display: 'flex',
                //   // justifyContent: 'space-between'
                // }}
                >
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between'
                      // alignItems: 'center'
                    }}
                  >
                    <div style={{ margin: -20 }}>
                      <img
                        alt=''
                        style={{ height: 120 }}
                        src={base_logo_url + AgencyAdminDetails?.userAvatar}
                      />
                    </div>
                    {/* <div>Salesperson : {rowData?.billToCompany}</div> */}
                    <div>
                      <Barcode
                        textPosition='top'
                        displayValue={true}
                        height={50}
                        fontSize={17}
                        width={1.5}
                        value={`Order # ${rowData?.pickupNumber}`}
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      marginTop: -5,
                      display: 'flex',
                      justifyContent: 'flex-end'
                      // alignItems: 'center'
                    }}
                  >
                    {/* <div>Customer : </div> */}
                    <div>{rowData.actualPickupDate}</div>
                  </div>
                </div>
                <div
                  style={{
                    display: 'flex',
                    // justifyContent: 'center',
                    width: '100%'
                  }}
                >
                  <div
                    style={{
                      padding: 10,
                      border: '0.5px solid black',
                      width: '100%'
                    }}
                  >
                    <div style={{ fontWeight: 'bold', fontSize: 18 }}>
                      Consignee/Ship To
                    </div>{' '}
                    <div style={{ marginLeft: 1 }}>
                      <div>{rowData?.originCompany}</div>
                      <div>{rowData?.originAddress}</div>
                      <div>
                        {rowData?.originContactPerson},{' '}
                        {rowData?.originZipCode +
                          ' ' +
                          rowData?.originCity +
                          ' ' +
                          rowData?.originState}
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      padding: 10,
                      border: '0.5px solid black',
                      width: '100%'
                    }}
                  >
                    <div style={{ fontWeight: 'bold', fontSize: 18 }}>
                      Sold To
                    </div>{' '}
                    <div style={{ marginLeft: 1 }}>
                      <div>{rowData?.destinationCompany}</div>

                      <div>{rowData?.destinationAddress}</div>
                      <div>
                        {rowData?.destinationContactPerson},
                        {rowData?.destinationZipCode +
                          ' ' +
                          rowData?.destinationCity +
                          ' ' +
                          rowData?.destinationState}
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <table style={{ marginTop: 10 }} className='custom-table'>
                    <thead
                      style={{
                        backgroundColor: 'rgb(222 222 222)',
                        fontWeight: 'bold',
                        border: 'none'
                      }}
                    >
                      <tr>
                        <th className='custom-col-100'>PO Number</th>
                        <th className='custom-col-100'>Terms</th>
                        <th className='custom-col-100'>Loc</th>
                        <th className='custom-col-100'>Ship Date</th>
                        <th className='custom-col-100'>Freight Terms</th>
                        <th className='custom-col-100'>Carrier</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{rowData?.clientPONumber}</td>
                        <td> </td>
                        <td>{rowData?.locationName}</td>
                        <td>{rowData.actualPickupDate}</td>
                        <td>{rowData?.freightTerms}</td>
                        <td>{rowData?.carrierName}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div>
                  <table style={{ marginTop: 10 }} className='custom-table'>
                    <thead
                      style={{
                        backgroundColor: 'rgb(222 222 222)',
                        fontWeight: 'bold',
                        border: 'none'
                      }}
                    >
                      <tr>
                        <th className='custom-col-100'>Customer Item</th>
                        <th className='custom-col-100'>Description</th>
                        <th className='custom-col-100'>Qty</th>
                        <th className='custom-col-100'>Class</th>
                      </tr>
                    </thead>
                    <tbody>
                      {viewShipmentsDetails.map(data => (
                        <tr>
                          <td>{data.customerId}</td>
                          <td>
                            {data.itemDescription} <br />
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between'
                              }}
                            >
                              <div>
                                <u>Batch</u> <br /> {data.itemNumber}
                              </div>
                              <div>
                                <u>Quantity</u> <br /> {data.netWeight}
                              </div>
                              <div>
                                <u>Nbr of Boxes</u> <br /> {data.pieces}
                              </div>
                              <div>
                                <u>Quantity Per</u> <br />
                              </div>
                            </div>
                          </td>
                          <td>{data.netWeight} LB</td>
                          <td>
                            {`FRT Class ${data.freightClass}` +
                              ' ' +
                              `NMFC ${data.nmfc}`}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <div className='page-break'></div>
                <div>
                  {/* <div>
                    <b>
                      For Chemical Emergency, Leak, Fire, Exposure, or Accident,
                      Call CHEMTREC1-800-424-9300 Day or Night
                    </b>
                  </div> */}
                  <div
                    style={{
                      display: 'flex',
                      // justifyContent: 'center',
                      width: '100%'
                    }}
                  >
                    <div
                      style={{
                        padding: 10,
                        border: '0.5px solid black',
                        width: '100%'
                      }}
                    >
                      <div>
                        This is to certify that the above named materials are
                        properly classified, described, packaged, marked and
                        labeled and are proper condition for transsportation
                        according to the applicable regulations of the
                        Department of Transportation.
                      </div>
                    </div>
                    <div
                      style={{
                        padding: 10,
                        border: '0.5px solid black',
                        width: '100%'
                      }}
                    >
                      <div>
                        If the shipment moves between two port carriers by
                        water, the law requires that the lading shall state
                        whether it is a "carrier shipper's weight." Note: Where
                        the rate is dependent on weight shippers are required to
                        state specifications writing the agreed or declared
                        value of property. The agreed or declared value of the
                        property hereby specifically states by the shipped to be
                        not exceeding ______________.
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      padding: 10,
                      border: '0.5px solid black',
                      width: '100%'
                    }}
                  >
                    <div>
                      SUBJECT TO SECTION 7 OF THE CONDITIONS OF APPLICABLE BILL
                      OF LADING, IF THE SHIPMENT IS TO BE DELIVERED TO THE
                      CONSIGNEE, WITHOUT RECOURSE ON THE CONSIGNOR, THE
                      CONSIGNOR SHALL SIGN THE FOLLOWING STATEMENT. THE CARRIER
                      SHALL NOT MAKE DELIVERY OF THIS SHIPMENT WITHOUT PAYMENT
                      OF FREIGHT AND ALL OTHER LAWFUL CHARGES. (Signature)
                      ____________________________.
                    </div>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      // justifyContent: 'center',
                      width: '100%'
                    }}
                  >
                    <div
                      style={{
                        padding: 10,
                        border: '0.5px solid black',
                        width: '100%'
                      }}
                    >
                      SHIPPER
                    </div>
                    <div
                      style={{
                        padding: 10,
                        border: '0.5px solid black',
                        width: '100%'
                      }}
                    >
                      AGENT
                    </div>
                  </div>
                </div>
              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ display: 'flex', justifyContent: 'center' }}>
            <Button
              size='small'
              variant='contained'
              onClick={generatePackagingSlipPdf}
            >
              Generate PDF
            </Button>
          </DialogActions>
        </Dialog>
        <Tabs
          orientation='vertical'
          variant='scrollable'
          value={valueY}
          onChange={handleChangeY}
          aria-label='Vertical tabs example'
          sx={{
            borderRight: 1,
            borderColor: 'divider',
            mr: 1
          }}
        >
          <Tab
            sx={{ display: 'flex', alignItems: 'flex-start' }}
            label='Shipment Info'
            {...a11yProps(0)}
          />

          <Tab
            sx={{ display: 'flex', alignItems: 'flex-start' }}
            label='Line Items'
            {...a11yProps(1)}
          />

          <Tab
            sx={{ display: 'flex', alignItems: 'flex-start' }}
            label='Addresses'
            {...a11yProps(2)}
          />
          {/* {(shipmentStatus === 'InTransit' ||
            shipmentStatus === 'Delivered' ||
            shipmentStatus === 'Booked') &&
            rowData?.shipmentType !== 'TL' && (
              <Tab
                sx={{ display: 'flex', alignItems: 'flex-start' }}
                label='Pricing'
                {...a11yProps(3)}
              />
            )} */}
          {(shipmentStatus === 'InTransit' ||
            shipmentStatus === 'Delivered' ||
            (rowData?.proNumber && shipmentStatus === 'Booked')) &&
            rowData?.shipmentType !== 'TL' && (
              <Tab
                sx={{ display: 'flex', alignItems: 'flex-start' }}
                label={
                  loader ? (
                    <CircularProgress sx={{ marginLeft: 8 }} size={22} />
                  ) : (
                    'Delivery Status'
                  )
                }
                {...a11yProps(3)}
                onClick={e =>
                  handleTrackShipmentRequest(props?.rowData, e, 'track')
                }
              />
            )}

          {(shipmentStatus === 'InTransit' || shipmentStatus === 'Delivered') &&
            rowData?.shipmentType === 'TL' && (
              <Tab
                sx={{ textAlign: 'right' }}
                label='Corresponding History'
                {...a11yProps(4)}
                onClick={() => setTLCoressPDrawer(true)}
              />
            )}
          {shipmentStatus !== 'Saved' &&
            shipmentStatus !== 'Tendered' &&
            rowData?.shipmentType !== 'TL' && (
              <Tab sx={{ textAlign: 'right' }} label='Shipment Analysis ' />
            )}

          {/* {(shipmentStatus === 'InTransit' || shipmentStatus === 'Delivered') &&
            props?.rowData?.shipmentType === 'LTL' && (
              <>
                <Button
                  size='small'
                  variant='outlined'
                  sx={{ mr: 1, width: 170 }}
                  onClick={() => handleBillOfLadingRequest('')}
                >
                  {docLoader ? (
                    <CircularProgress size={22} />
                  ) : (
                    <>
                      Bill of Lading
                      <DownloadIcon sx={{ fontSize: 18 }} />
                    </>
                  )}
                </Button>
              </>
            )} */}
          {shipmentStatus === 'Booked' &&
            props?.rowData?.shipmentType !== 'TL' && (
              <>
                {/* <Tooltip title='Print Lables' arrow>
                          <Button
                            sx={{ zIndex: 1 }}
                            onClick={() => printData(row.original)}
                          >
                            <PrintIcon />
                          </Button>
                        </Tooltip> */}
                <Button
                  onClick={() => printData(props?.rowData)}
                  sx={{ mt: 2, mr: 1, width: 170 }}
                  size='small'
                  variant='outlined'
                >
                  Print Lables
                </Button>
              </>
            )}
          {shipmentStatus === 'Delivered' &&
            props?.rowData?.shipmentType === 'LTL' && (
              <Button
                sx={{ mt: 2, mr: 1, width: 170 }}
                size='small'
                variant='outlined'
                onClick={() => handleProofOfDeliveryRequest('')}
              >
                {PodDocLoader ? (
                  <CircularProgress size={22} />
                ) : (
                  <>
                    Proof of Delivery
                    <DownloadIcon sx={{ fontSize: 18 }} />
                  </>
                )}
              </Button>
            )}
          {(shipmentStatus === 'InTransit' ||
            shipmentStatus === 'Delivered' ||
            shipmentStatus === 'Booked') &&
            props?.rowData?.shipmentType === 'LTL' && (
              <Button
                sx={{ mt: 2, mr: 1, width: 170 }}
                size='small'
                variant='outlined'
                onClick={() => setOpenPrintPDfDialog(true)}
              >
                Bill of Lading
                <DownloadIcon sx={{ fontSize: 18 }} />
              </Button>
            )}

          {/* {(shipmentStatus === 'InTransit' || shipmentStatus === 'Delivered') &&
            props?.rowData?.shipmentType === 'LTL' && (
              <Button
                sx={{ mt: 2, mr: 1, width: 170 }}
                size='small'
                variant='outlined'
                onClick={() => handlePackagingSlip()}
              >
                Packaging Slip
                <DownloadIcon sx={{ fontSize: 18 }} />
              </Button>
            )} */}
        </Tabs>
        <TabPanel value={valueY} index={0}>
          <Box sx={{ bgcolor: 'background.paper', width: '90vw' }}>
            <TabPanelX value={valueX} index={0}>
              <Row>
                {
                  <Col lg={3} xl={3}>
                    <div style={{ marginTop: 10 }}>
                      <div className='View_Details_Headings'>Shipment #</div>
                      <span className='View_Details'>{rowData.soNumber}</span>
                    </div>

                    {(shipmentStatus === 'InTransit' ||
                      shipmentStatus === 'Delivered' ||
                      shipmentStatus === 'Booked') &&
                    rowData.shipmentType === 'TL' ? (
                      <div style={{ marginTop: 10 }}>
                        <div className='View_Details_Headings'>
                          Service Type
                        </div>
                        <span className='View_Details'>
                          {rowData.pickupNumber}
                        </span>
                      </div>
                    ) : (
                      (shipmentStatus === 'InTransit' ||
                        shipmentStatus === 'Delivered' ||
                        shipmentStatus === 'Delivered' ||
                        shipmentStatus === 'Booked') && (
                        <div style={{ marginTop: 10 }}>
                          <div className='View_Details_Headings'>
                            Pickup Request Number
                          </div>

                          <span className='View_Details'>
                            {' '}
                            {rowData.pickupNumber}
                          </span>
                        </div>
                      )
                    )}
                  </Col>
                }

                {(shipmentStatus === 'InTransit' ||
                  shipmentStatus === 'Delivered' ||
                  shipmentStatus === 'Booked') &&
                rowData.shipmentType === 'Parcel' ? (
                  <Col lg={3} xl={3}>
                    <div style={{ marginTop: 10 }}>
                      <div className='View_Details_Headings'>Tracking#</div>
                      <span className='View_Details'> {rowData.proNumber}</span>
                    </div>
                  </Col>
                ) : (
                  (shipmentStatus === 'InTransit' ||
                    shipmentStatus === 'Delivered' ||
                    shipmentStatus === 'Booked') &&
                  rowData.shipmentType !== 'TL' &&
                  (rowData.proNumber || rowData.bolNumber) && (
                    <Col lg={3} xl={3}>
                      {rowData.proNumber && (
                        <div style={{ marginTop: 10 }}>
                          <div className='View_Details_Headings'>PRO# </div>
                          <span className='View_Details'>
                            {' '}
                            {rowData.proNumber}
                          </span>
                        </div>
                      )}

                      {rowData.bolNumber && (
                        <div style={{ marginTop: 10 }}>
                          <div className='View_Details_Headings'>BOL#</div>
                          <span className='View_Details'>
                            {rowData.bolNumber}
                          </span>
                        </div>
                      )}
                    </Col>
                  )
                )}

                <Col lg={3} xl={3}>
                  {rowData.quoteNumber && rowData.shipmentType !== 'Parcel' && (
                    <div style={{ marginTop: 10, whiteSpace: 'nowrap' }}>
                      <div className='View_Details_Headings'>
                        Reference/Quote
                      </div>

                      {rowData.quoteNumber}
                    </div>
                  )}
                  <div style={{ marginTop: 10 }}>
                    <div className='View_Details_Headings'>Purchase Order#</div>

                    <span className='View_Details'>
                      {' '}
                      {rowData.clientPONumber}
                    </span>
                  </div>
                </Col>

                <Col lg={3} xl={3}>
                  <div
                    style={
                      rowData.quoteNumber ? { marginTop: 10 } : { marginTop: 1 }
                    }
                  >
                    <div className='View_Details_Headings'> Location Name</div>

                    <div className='View_Details'>{rowData.locationName}</div>
                    {rowData.shipmentMiles ? (
                      <>
                        <div
                          style={{ marginTop: 10 }}
                          className='View_Details_Headings'
                        >
                          {' '}
                          Shipment Distance
                        </div>
                        <div className='View_Details'>
                          {/* {convertMetersToMiles(rowData.shipmentMiles).toFixed(2)}{' '} */}
                          {rowData.shipmentMiles} miles
                        </div>
                      </>
                    ) : null}
                  </div>
                </Col>
              </Row>
            </TabPanelX>
          </Box>
        </TabPanel>

        <TabPanel value={valueY} index={1}>
          <Box>
            <TabPanelX value={valueX} index={0}>
              <Row>
                <Col lg={12} xl={12}>
                  <TableContainer sx={{ width: '70vw' }} component={Paper}>
                    <Table
                      sx={{ width: '70vw' }}
                      // size='small'
                      // aria-label='a dense table'
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 'bold' }} align='left'>
                            Unit Type
                          </TableCell>
                          <>
                            <TableCell sx={{ fontWeight: 'bold' }} align='left'>
                              # of Units
                            </TableCell>
                            {rowData?.shipmentType !== 'TL' && (
                              <TableCell
                                sx={{ fontWeight: 'bold' }}
                                align='left'
                              >
                                # of Pieces
                              </TableCell>
                            )}
                          </>
                          <TableCell sx={{ fontWeight: 'bold' }} align='left'>
                            NMFC
                          </TableCell>

                          {rowData?.shipmentType !== 'Parcel' && (
                            <TableCell sx={{ fontWeight: 'bold' }} align='left'>
                              Freight Class
                            </TableCell>
                          )}
                          <TableCell sx={{ fontWeight: 'bold' }} align='left'>
                            {rowData?.shipmentType === 'TL'
                              ? 'Net Weight'
                              : 'Weight'}{' '}
                            (lbs)
                          </TableCell>
                          {rowData?.shipmentType === 'TL' && (
                            <TableCell sx={{ fontWeight: 'bold' }} align='left'>
                              Gross Weight (lbs)
                            </TableCell>
                          )}

                          {/* <TableCell sx={{ fontWeight: 'bold' }} align='left'>
                            NMFC
                          </TableCell> */}
                          <TableCell sx={{ fontWeight: 'bold' }} align='left'>
                            Dimensions (L W H)
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {viewShipmentsDetails.map(row => (
                          <TableRow
                            key={row.name}
                            // sx={{
                            //   '&:last-child td, &:last-child th': { border: 0 }
                            // }}
                          >
                            <TableCell align='left'>
                              {row.packagingType}
                            </TableCell>
                            <TableCell align='left'>{row.units}</TableCell>
                            {rowData?.shipmentType !== 'TL' && (
                              <>
                                <TableCell align='left'>{row.pieces}</TableCell>
                              </>
                            )}
                            <TableCell align='left'>
                              {rowData?.shipmentType === 'TL' ? ' ' : row.nmfc}
                            </TableCell>

                            {rowData?.shipmentType !== 'Parcel' && (
                              <TableCell align='left'>
                                {row.freightClass}
                              </TableCell>
                            )}
                            <TableCell align='left'>{row.netWeight}</TableCell>
                            {rowData?.shipmentType === 'TL' && (
                              <TableCell align='left'>
                                {row.grossWeight}
                              </TableCell>
                            )}
                            <TableCell align='left'>
                              {row.length} x {row.width} x {row.height}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Col>
              </Row>
            </TabPanelX>
          </Box>
        </TabPanel>

        <TabPanel value={valueY} index={2}>
          <TabPanelX value={valueX} index={0}>
            <Row>
              <Col lg={12} xl={12}>
                <TableContainer sx={{ width: '70vw' }} component={Paper}>
                  <Table
                    sx={{ width: '70vw' }}
                    // size='small'
                    // aria-label='a dense table'
                  >
                    <TableHead>
                      <TableRow>
                        {/* <TableCell sx={{ fontWeight: 'bold' }}>
                          Lables
                        </TableCell> */}
                        <TableCell sx={{ fontWeight: 'bold' }}>
                          Origin Information
                        </TableCell>
                        <TableCell sx={{ fontWeight: 'bold' }} align='left'>
                          Destination Information
                        </TableCell>
                        <TableCell sx={{ fontWeight: 'bold' }} align='left'>
                          Bill To Information
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {(rowData.originCompany ||
                        rowData.destinationCompany ||
                        rowData.billToCompany) && (
                        <TableRow
                          sx={{
                            '&:last-child td, &:last-child th': { border: 0 }
                          }}
                        >
                          {/* <TableCell component='th' scope='row'>
                            <b>Company Name</b>
                          </TableCell> */}
                          <TableCell align='left'>
                            {rowData.originCompany}
                          </TableCell>
                          <TableCell align='left'>
                            {rowData.destinationCompany}
                          </TableCell>
                          <TableCell align='left'>
                            {rowData.billToCompany}
                          </TableCell>
                        </TableRow>
                      )}

                      {(rowData.originAddress ||
                        rowData.destinationAddress ||
                        rowData.billToAddress) && (
                        <TableRow
                          sx={{
                            '&:last-child td, &:last-child th': { border: 0 }
                          }}
                        >
                          <TableCell align='left'>
                            {rowData.originAddress}{' '}
                            {rowData.originAddress2 &&
                              `, ${rowData.originAddress2}`}
                          </TableCell>
                          <TableCell align='left'>
                            {rowData.destinationAddress}{' '}
                            {rowData.destinationAddress2 &&
                              `, ${rowData.destinationAddress2}`}
                          </TableCell>
                          <TableCell align='left'>
                            {rowData.billToAddress}{' '}
                            {rowData.billToAddress2 &&
                              `, ${rowData.billToAddress2}`}
                          </TableCell>
                        </TableRow>
                      )}

                      <TableRow
                        sx={{
                          '&:last-child td, &:last-child th': { border: 0 }
                        }}
                      >
                        <TableCell align='left'>
                          {rowData.originZipCode +
                            ', ' +
                            rowData.originCity +
                            ', ' +
                            rowData.originState}
                        </TableCell>

                        <TableCell align='left'>
                          {rowData.destinationZipCode +
                            ', ' +
                            rowData.destinationCity +
                            ', ' +
                            rowData.destinationState}
                        </TableCell>
                        <TableCell align='left'>
                          {rowData.billToZipCode &&
                            rowData.billToZipCode +
                              ', ' +
                              rowData.billToCity +
                              ', ' +
                              rowData.billToState}
                        </TableCell>
                      </TableRow>

                      {(rowData.originContactPhone ||
                        rowData.destinationContactPhone ||
                        rowData.billToContactPhone) && (
                        <TableRow
                          sx={{
                            '&:last-child td, &:last-child th': { border: 0 }
                          }}
                        >
                          <TableCell align='left'>
                            {formatPhoneNumber(rowData.originContactPhone)}
                          </TableCell>
                          <TableCell align='left'>
                            {formatPhoneNumber(rowData.destinationContactPhone)}
                          </TableCell>
                          <TableCell align='left'>
                            {formatPhoneNumber(rowData.billToContactPhone)}
                          </TableCell>
                        </TableRow>
                      )}

                      {(rowData.originContactEmail ||
                        rowData.destinationContactEmail ||
                        rowData.billToContactEmail) && (
                        <TableRow
                          sx={{
                            '&:last-child td, &:last-child th': { border: 0 }
                          }}
                        >
                          <TableCell align='left'>
                            {rowData.originContactEmail}
                          </TableCell>
                          <TableCell align='left'>
                            {rowData.destinationContactEmail}
                          </TableCell>
                          <TableCell align='left'>
                            {rowData.billToContactEmail}
                          </TableCell>
                        </TableRow>
                      )}
                      {/* )} */}
                      <TableRow
                        sx={{
                          '&:last-child td, &:last-child th': { border: 0 }
                        }}
                      >
                        <TableCell align='left'>
                          <b>
                            {shipmentStatus === 'InTransit' ||
                            shipmentStatus === 'Delivered'
                              ? 'Actual Pickup Date'
                              : 'Requested Pickup Date'}{' '}
                            :
                          </b>{' '}
                          {shipmentStatus === 'InTransit' ||
                          shipmentStatus === 'Delivered'
                            ? rowData.actualPickupDate
                            : rowData.pickupDate}
                        </TableCell>
                        <TableCell align='left'>
                          <b>
                            {shipmentStatus === 'Delivered'
                              ? 'Actual Delivery Date'
                              : 'Est. Delivery Date'}{' '}
                            :
                          </b>{' '}
                          {shipmentStatus === 'Delivered'
                            ? rowData.actualDeliveryDate
                            : rowData.deliveryDate}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Col>
            </Row>
          </TabPanelX>
        </TabPanel>
        {/* Surcharge Details  */}
        {/* <TabPanel value={valueY} index={3}>
          <TabPanelX value={valueX} index={0}>
            <Row>
              <Col lg={12} xl={12}>
                <TableContainer sx={{ width: '70vw' }} component={Paper}>
                  <Table
                    sx={{ width: '70vw' }}
                    // size='small'
                    // aria-label='a dense table'
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 'bold' }}>
                          Charges Detail
                        </TableCell>
                        <TableCell sx={{ fontWeight: 'bold' }}>
                          Charges
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rowData?.surchargesList
                        ?.sort(applySubChargesSort)
                        .map(surcharge => (
                          <TableRow
                            sx={{
                              '&:last-child td, &:last-child th': { border: 0 }
                            }}
                          >
                            <TableCell align='left'>
                              {`${surcharge.description}`}
                            </TableCell>
                            <TableCell align='left'>
                              {surcharge?.description?.includes('%')
                                ? `${surcharge.amount?.amount.toFixed(2)}%`
                                : formatePrice(surcharge.amount?.amount)}
                            </TableCell>
                          </TableRow>
                        ))}
                      <TableRow
                        sx={{
                          '&:last-child td, &:last-child th': { border: 0 }
                        }}
                      >
                        <TableCell sx={{ fontWeight: 'bold' }}>
                          Total Price
                        </TableCell>
                        <TableCell sx={{ fontWeight: 'bold' }}>
                          ${rowData?.shipmentCharges?.toFixed(2)}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Col>
            </Row>
          </TabPanelX>
        </TabPanel> */}

        {shipmentStatus !== 'Booked' && (
          <TabPanel value={valueY} index={3}>
            <TabPanelX value={valueX} index={0}>
              {rowData?.shipmentType === 'TL' ? (
                (shipmentStatus === 'InTransit' ||
                  shipmentStatus === 'Delivered') && (
                  <div>
                    <Drawer
                      anchor='right'
                      open={TLCoressPDrawer}
                      onClose={handleCloaseTLCoressPDrawer}
                    >
                      <div className='d-flex flex-column justify-content-center h-100'>
                        {!docLoader ? (
                          historyError ? (
                            <Box
                              sx={{ textAlign: 'center' }}
                              className='Chat_Child_View_Shipment'
                            >
                              <br />
                              <br />
                              <br />
                              <br />
                              <WarningAmberIcon
                                style={{ fontSize: 150, color: '#D32F2F' }}
                              />{' '}
                              {/* <br /> */}
                              <br />
                              <Typography variant='h5'>
                                No history found for this shipment!
                              </Typography>
                              <br />
                              <br />
                              <br />
                            </Box>
                          ) : (
                            <div className='Chat_Child_View_Shipment py-2 pt-4 h-100'>
                              {shipperApiMsgs &&
                                shipperApiMsgs.map(carrierRes => (
                                  <div
                                    style={
                                      carrierRes.actionByFlag.toLowerCase() ===
                                      'carrier'
                                        ? {
                                            display: 'flex',
                                            justifyContent: 'start',
                                            flexDirection: 'column',
                                            marginLeft: 10,
                                            marginRight: 10,
                                            width: 400,
                                            position: 'relative'
                                          }
                                        : {
                                            display: 'flex',
                                            justifyContent: 'end',
                                            // flexDirection: 'column',
                                            marginLeft: 10,
                                            marginRight: 10,
                                            position: 'relative'
                                          }
                                    }
                                  >
                                    {carrierRes.actionByFlag.toLowerCase() ===
                                      'carrier' && (
                                      <div
                                        style={{
                                          display: 'flex',
                                          justifyContent: 'start'
                                        }}
                                      >
                                        <div
                                          style={{
                                            backgroundColor: '#e0f2f1',
                                            borderRadius: '50%',
                                            width: '45',
                                            height: '45',
                                            textAlign: 'center',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            marginRight: 10
                                          }}
                                        >
                                          <img
                                            style={{
                                              borderRadius: '50%',
                                              width: '45',
                                              height: '45',
                                              textAlign: 'center',
                                              display: 'flex',
                                              justifyContent: 'center',
                                              objectFit: 'cover'
                                            }}
                                            alt=''
                                            src={
                                              base_logo_url +
                                              carrierApiMsgs[0]?.actionByImage
                                            }
                                          />
                                        </div>
                                        <div>
                                          <b style={{ fontSize: 18 }}>
                                            {carrierApiMsgs &&
                                              carrierApiMsgs[0]?.actionByName}
                                          </b>
                                          <br />
                                          <span style={{ fontWeight: 600 }}>
                                            {
                                              carrierApiMsgs[0]
                                                ?.actionByDesignation
                                            }
                                          </span>
                                        </div>
                                      </div>
                                    )}
                                    <div>
                                      {carrierRes.actionByFlag.toLowerCase() ===
                                        'shipper' && (
                                        <div
                                          style={{
                                            display: 'flex',
                                            justifyContent: 'end'
                                          }}
                                        >
                                          <div
                                            style={{
                                              marginLeft: 0,
                                              marginRight: 1,
                                              textAlign: 'right'
                                            }}
                                          >
                                            <b style={{ fontSize: 18 }}>
                                              {shipperApiMsgs &&
                                                shipperApiMsgs[0]?.actionByName}
                                            </b>
                                            <br />
                                            <span style={{ fontWeight: 600 }}>
                                              {
                                                shipperApiMsgs[0]
                                                  ?.actionByDesignation
                                              }
                                            </span>
                                            <br />
                                          </div>
                                          <div
                                            style={{
                                              backgroundColor: '#e0f2f1',
                                              borderRadius: '50%',
                                              width: '45',
                                              height: '45',
                                              textAlign: 'center',
                                              display: 'flex',
                                              justifyContent: 'center',
                                              marginLeft: 10
                                            }}
                                          >
                                            <img
                                              style={{
                                                borderRadius: '50%',
                                                width: '45',
                                                height: '45',
                                                textAlign: 'center',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                objectFit: 'cover'
                                              }}
                                              alt=''
                                              src={
                                                base_logo_url +
                                                shipperApiMsgs[0]?.actionByImage
                                              }
                                            />
                                          </div>
                                        </div>
                                      )}
                                      <div
                                        style={
                                          carrierRes.actionByFlag.toLowerCase() ===
                                          'shipper'
                                            ? {
                                                marginBottom: '10vh',
                                                backgroundColor: '#e0f2f1',
                                                borderRadius:
                                                  '10px 0px 10px 10px',
                                                padding: '10px',
                                                transform: '(rotateX(180deg)'
                                              }
                                            : {
                                                marginBottom: '10vh',
                                                backgroundColor: '#eceff1',
                                                padding: '10px',
                                                borderRadius:
                                                  '0px 10px 10px 10px'
                                              }
                                        }
                                      >
                                        <div
                                          style={{ fontSize: 12 }}
                                          dangerouslySetInnerHTML={{
                                            __html: handleCorresHistory(
                                              carrierRes.actionData
                                            )
                                          }}
                                        ></div>
                                        <div
                                          style={{
                                            display: 'flex',
                                            justifyContent: 'flex-end',
                                            fontSize: 11
                                          }}
                                        >
                                          {handleDateTimeShow(
                                            carrierRes.date,
                                            'time'
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ))}

                              {/* <div ref={bottomRef} /> */}
                            </div>
                          )
                        ) : (
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              width: '50vw',
                              height: '90%'
                            }}
                          >
                            <CircularProgress />
                          </div>
                        )}
                      </div>
                    </Drawer>
                  </div>
                )
              ) : (
                <Box sx={{ height: '40vh' }}>
                  <Col xl={10} lg={10}>
                    {trackShipmentData && (
                      <div
                        style={{
                          display: 'flex',
                          // justifyContent: 'space-between',
                          // alignItems: 'center',
                          flexDirection: 'column-reverse',
                          // backgroundColor: 'red',
                          width: '100%'
                        }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'start'
                          }}
                        >
                          <TrackShipmentDetails
                            trackShipmentData={trackShipmentData}
                            view={viewType}
                            rowData={rowData}
                          />
                        </div>
                      </div>
                    )}
                  </Col>
                </Box>
              )}
            </TabPanelX>
          </TabPanel>
        )}
        <TabPanel value={valueY} index={rowData?.proNumber ? 4 : 3}>
          <Box sx={{ bgcolor: 'background.paper', width: '90vw' }}>
            <TabPanelX value={valueX} index={0}>
              <Row>
                <Col lg={12} xl={12}>
                  <TableContainer sx={{ width: '70vw' }} component={Paper}>
                    <Table
                      sx={{ width: '70vw' }}
                      // size='small'
                      // aria-label='a dense table'
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 'bold' }} align='left'>
                            Labels
                          </TableCell>
                          <TableCell sx={{ fontWeight: 'bold' }}>
                            Lowest Cost Carrier
                          </TableCell>
                          <TableCell sx={{ fontWeight: 'bold' }} align='left'>
                            Booked Carrier
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow
                          sx={{
                            textAlign: 'right',
                            '&:last-child td, &:last-child th': { border: 0 }
                          }}
                        >
                          <TableCell align='left'>
                            <b>Carrier Name</b>:
                          </TableCell>
                          <TableCell align='right'>
                            <div
                              className='View_Details'
                              style={
                                rowData.leastCostCarrierLogo
                                  ? {
                                      marginLeft: -10,
                                      height: 20,
                                      display: 'flex',
                                      alignItems: 'center',
                                      textAlign: 'left',
                                      alignSelf: 'self-start'
                                    }
                                  : {
                                      height: 20,
                                      display: 'flex',
                                      alignItems: 'center',
                                      textAlign: 'left',
                                      alignSelf: 'self-start'
                                    }
                              }
                            >
                              {rowData.leastCostCarrierLogo ? (
                                <AvatarGroup sx={{ gap: 'small' }}>
                                  <Avatar
                                    sx={{
                                      fontSize: '14px',
                                      width: 40,
                                      height: 40
                                    }}
                                    imgProps={{
                                      style: {
                                        height: 25
                                      }
                                    }}
                                    src={
                                      rowData.leastCostCarrierLogo
                                        ? base_logo_url +
                                          rowData.leastCostCarrierLogo
                                        : NoLogo
                                    }
                                  ></Avatar>
                                </AvatarGroup>
                              ) : (
                                'Not Available'
                              )}
                              {rowData.leastCostCarrierName}
                            </div>
                          </TableCell>
                          <TableCell align='right'>
                            <div
                              className='View_Details'
                              style={{
                                marginLeft: -10,
                                height: 20,
                                display: 'flex',
                                alignItems: 'center',
                                textAlign: 'left',
                                alignSelf: 'self-start'
                              }}
                            >
                              <AvatarGroup sx={{ gap: 'small' }}>
                                <Avatar
                                  sx={{
                                    fontSize: '14px',
                                    width: 40,
                                    height: 40
                                  }}
                                  imgProps={{
                                    style: {
                                      height: 25
                                    }
                                  }}
                                  src={
                                    rowData.carrierLogo
                                      ? base_logo_url + rowData.carrierLogo
                                      : NoLogo
                                  }
                                ></Avatar>
                              </AvatarGroup>
                              {rowData.carrierName}
                            </div>
                          </TableCell>
                        </TableRow>

                        <TableRow
                          sx={{
                            '&:last-child td, &:last-child th': { border: 0 }
                          }}
                        >
                          <TableCell align='left'>
                            <b>Rate</b>:
                          </TableCell>
                          <TableCell align='left'>
                            <div className='View_Details'>
                              {rowData.leastCost
                                ? `$${(
                                    rowData.leastCost +
                                    rowData.leastCostAgencySurcharge
                                  ).toFixed(2)}`
                                : 'Not Available'}
                            </div>
                          </TableCell>
                          <TableCell align='left'>
                            <div className='View_Details'>
                              ${rowData.shipmentCharges}
                            </div>
                          </TableCell>
                        </TableRow>
                        <TableRow
                          sx={{
                            '&:last-child td, &:last-child th': { border: 0 }
                          }}
                        >
                          <TableCell align='left'>
                            <b>Transit Days</b>:
                          </TableCell>
                          <TableCell align='left'>
                            <div className='View_Details'>
                              {rowData.leastTransitDays
                                ? rowData.leastTransitDays
                                : 'Not Available'}
                            </div>
                          </TableCell>
                          <TableCell align='left'>
                            <div className='View_Details'>
                              {rowData.estimatedTransitDays}
                            </div>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Col>
              </Row>
              {/* <Row>
                <Col lg={4} xl={4}>
                  <div style={{ marginTop: 10 }}>
                    <div className='View_Details_Headings'>
                      {' '}
                      Least Cost Carrier Name
                    </div>

                    <div
                      className='View_Details'
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        textAlign: 'left',
                        alignSelf: 'self-start'
                      }}
                    >
                      <AvatarGroup sx={{ gap: 'small' }}>
                        <Avatar
                          sx={{
                            fontSize: '14px',
                            width: 40,
                            height: 40
                          }}
                          imgProps={{
                            style: {
                              height: 25
                            }
                          }}
                          src={
                            rowData.leastCostCarrierLogo
                              ? base_logo_url + rowData.leastCostCarrierLogo
                              : NoLogo
                          }
                        ></Avatar>
                      </AvatarGroup>
                      {rowData.leastCostCarrierName}
                    </div>
                  </div>
                </Col>
                <Col lg={4} xl={4}>
                  <div style={{ marginTop: 10 }}>
                    <div className='View_Details_Headings'>
                      {' '}
                      Least Cost Carrier Rate
                    </div>

                    <div className='View_Details'>${rowData.leastCost}</div>
                  </div>
                </Col>
                <Col lg={4} xl={4}>
                  <div style={{ marginTop: 10 }}>
                    <div className='View_Details_Headings'>
                      {' '}
                      Least Cost Carrier Days
                    </div>

                    <div className='View_Details'>
                      {rowData.leastTransitDays}
                    </div>
                  </div>
                </Col>
              </Row> */}
            </TabPanelX>
          </Box>
        </TabPanel>
      </Box>
    </div>
  );
}

export default ViewShipment;
